import axios from "axios";
import { data } from "react-router-dom";
// Mapping section types
const SECTION_TYPE_MAP = {
  parishisht1: "Parishisht-1",
  anusuchi2: "Anusuchi-2",
  parishisht6: "Parishisht-6",
  namukoK: "Namuko-K",
  section11: "Section-11",
  section12: "Section-12",
  section19: "Section-19",
  section15: "Section-15",
  section21: "Section-21",
  section23: "Section-23",
  anusuchi3: "Anusuchi-3",
  report: "Report",
  otherdocuments: "Otherdocuments",
  CoveringLettersSection11: "CoveringLetters-Section11",
  Kalam11: "Kalam11",
  Praruplist: "Praruplist",
  Finallist: "Finallist",
  Namunakdro: "NamunakDro",
  LandReport: "LandReport",
  NamunaB: "NamunaB",
  NamunaA: "NamunaA",
  PrarupReport: "PrarupReport",
  PrarupTippani: "PrarupTippani",
  AkshepReport: "AkshepReport",
  AkshepTappani: "AkshepTappani",
  FinalLand: "FinalLand",
  FinalTippni: "FinalTippni",
  TabaPauti: "TabaPauti",
  TabaPautiTippani: "TabaPautiTippani",
};
export const baseURL = "https://bhusampadan-be-jagdish.onrender.com";
class ApiService {
  constructor() {
    this.api = axios.create({
      // baseURL: 'https://bhusampadan-be-jagdish.com',
      // baseURL: 'https://bhusampadan-be-jagdish.onrender.com',
      // baseURL: 'http://108.181.203.8:1099',
      // baseURL: 'http://localhost:1099',
      // baseURL: 'http://192.168.0.7:1099',
      baseURL: "https://iisdigital.cloud",
      // timeout: 10000,

      headers: {},
    });

    // Simple cache for API responses
    this.cache = new Map();
    this.cacheTimeout = 5 * 60 * 1000; // 5 minutes

    this.setupInterceptors();

    // API endpoints
    this.endpoints = {
      LOGIN: "/postLogin",
      REGISTER: "/postRegistration",
      VERIFY_LOGIN_OTP: "/postVerifyLoginOTP",
      LOGOUT: "/postLogout",

      // Profile APIs
      GET_PROFILE: "/getProfile",
      UPDATE_PROFILE: "/updateProfile",

      // Role Management APIs
      GET_ALL_ASSIGN_ROLE: "/getAllAssignRole",
      SEARCH_USER: "/getUserSearch",
      GET_ALL_USER_ROLE: "/getAllUserRole",
      GET_ALL_PROJECT: "/getAllProject",
      GET_ALL_PROJECT_BEFORE_LOGIN: "/getAllProjectBeforeLogin",
      GET_ALL_PROJECTS: "/getAllProjects",
      POST_ADD_ASSIGN_ROLE: "/postAddAssignRole",

      // Project APIs
      PATCH_UPDATE_PROJECT: "/patchUpdateProject",
      POST_ADD_PROJECT: "/postAddProject",
      GET_ALL_USER: "/getAllUser",
      GET_TRACKING: "/getTracking",
      GET_ALL_PROJECTS_PAGINATE: "/getAllProjectsPaginate",
      GET_USER_PROJECT: "/getAllUserProject",

      // Land Type APIs
      GET_LAND_TYPE: "/getLandType",
      POST_ADD_LAND_TYPE: "/postAddLandType",
      PATCH_UPDATE_LAND_TYPE: "/patchUpdateLandType",
      DELETE_LAND_TYPE: "/deleteLandType",

      // Land Rate APIs
      GET_LAND_RATE: "/getLandRate",

      // Area Unit APIs
      GET_AREA_UNIT: "/getAreaUnit",
      POST_ADD_AREA_UNIT: "/postAddAreaUnit",
      PATCH_UPDATE_AREA_UNIT: "/patchUpdateAreaUnit",

      // Act APIs
      GET_ACT: "/getAct",

      // Management APIs
      GET_USER: "/getAllUser",

      //Objection
      POST_ADD_GENERAL_OBJECTION: "/postAddGeneralObjection",
      GET_GENERAL_OBJECTIONS: "/getGeneralObjection",
      PATCH_UPDATE_GENERAL_OBJECTION: "/patchUpdateGeneralObjection",

      //Send OTP
      SEND_EMAIL_OTP_OBJECTION: "/getSendEmailOtpObjection",
      VERIFY_OBJECTION_OTP: "/postObjectionOtpVerify",

      //LandHolding List
      GET_LANDHOLDING: "/getLandHolding",
      GET_UPDATE_LANDHOLDING: "/patchUpdateLandHolding",
      POST_ADD_LANDHOLDING: "/postAddLandHolding",
      DELETE_LANDHOLDING: "/deleteLandHolding", // Added missing delete endpoint
      UPDATE_LANDHOLDING_STATUS: "/patchUpdateLandHoldingStatus", // Added missing status update endpoint
      GET_LANDHOLDING_Type: "/getLandHoldingType",

      //Village
      GET_VILLAGE: "/getVillage",
      GET_DISTRICTS: "/getDistrict",
      GET_TALUKAS: "/getTaluka",

      // Forgot Password APIs
      PASSWORD_EMAIL: "/postPasswordEmail",
      PASSWORD_EMAIL_OTP: "/postPasswordEmailOtp",
      FORGOT_PASSWORD: "/postForgotPassword",

      // Village Management APIs
      // GET_ALL_VILLAGE: '/getVillageAllData',
      GET_ALL_VILLAGE: "/getAllVillage",
      PATCH_VILLAGE_ISACTIVE: "/patchVillageIsActive",

      //Mesurement
      GET_MEASUREMENT: "/getMeasurement",
      GET_MEASUREMENT_BY_LAND_ID: "/getMeasurement",
      GET_MEASUREMENT_OWNER_ID: "/getMeasurement",
      ADD_MEASUREMENT: "/postAddMeasurement",
      UPDATE_MEASUREMENT: "/patchUpdateMeasurement",
      PATCH_UPDATE_LAND_HOLDING: "/patchUpdateLandHolding",
      GET_ALL_OWNER: "/getAllOwner",

      // Hearing Management APIs
      POST_HEARING: "/postHearing",
      GET_HEARING: "/getHearing",
      SEND_HEARING_NOTICE_MAIL: "/postSendHearingNoticeMail",

      //MarketValue
      GET_OWNER_MARKET_VALUE: "/getOwnerMarketValue",
      POST_ADD_UPDATE_OWNER_MARKET_VALUE: "/postAddUpdateOwnerMarketValue",

      // Reports
      GET_STAGEWISE_PROJECT: "/getStagewiseProject",

      // Compensation
      GET_OWNER_COMPENSATION: "/getOwnerCompensation",
      POST_ADD_OWNER_COMPENSATION: "/postAddOwnerCompensation",
      PATCH_UPDATE_OWNER_COMPENSATION: "/patchUpdateOwnerCompensation",

      //payment
      GET_PAYMENT: "/getPaymentCompensation",
      POST_ADD_PAYMENT: "/postAddPayment",

      //PrivateObjection
      POST_ADD_PRIVATE_OBJECTION: "/postAddPrivateObjection",
      GET_PRIVATE_OBJECTIONS: "/getPrivateObjection",

      //Final Award
      GET_FINAL_AWARD: "/getFinalAward",

      //Send to LAO
      POST_TRACKING: "/postTracking",
      GET_BUTTON_DISABLE: "/getSendButton",
      SEND_TO_NEXT: "/postSendToNext",
      GET_BUTTON : "/getTrackingwiseDisable",
      GET_TRACKING_PERMISSION : "/getTrackingPermission",
      PATCH_TRACKING_PERMISSION : "/patchUpdateTrackingPermission",

      //KJP
      GET_KJP: "/getKJP",
      PATCH_UPDATE_KJP: "/patchUpdateMeasurement",

      //Search
      GET_SEARCH: "/getSearch",

      // Proposal APIs
      GET_PROPOSALS: "/getProposal",
      GET_TALUKAVILLAGE: "/getTalukaVill",
      GET_ALL_CATEGORY: "/getAllCategory",
      GET_ALL_USER_PROPOSALS: "/getAllUserProposal",
      ADD_PROPOSAL: "/postAddProposal",
      PATCH_UPDATE_PROPOSAL: "/patchUpdateProposal",
      GET_PROPOSAL_PUBLISH: "/getProposal",
      UPDATE_PROPOSAL_PUBLISH: "/patchUpdateProposal",

      //PAP
      GET_PAP: "/getPAP",

      GET_DIRECT_PURCHASE_KJP: "/getDirectPurchaseKJP",
      POST_ADD_DIRECT_PURCHASE: "/postAddDirectPurchase",
      PATCH_UPDATE_DIRECT_PURCHASE: "/patchUpdateDirectPurchase",

      // Namuna K
      GET_NAMUNA_K: "getNamunoK",
      POST_ADD_UPDATE_NAMUNA_K: "postAddUpdateNamunoK",

      // ADD Signature
      POST_ADD_SIGNATURE_PDF: "/postAddSignaturePDF",
      GET_SECTIONS: "/getSections",

      // Asset Property
      PATCH_UPDATE_TREE: "/patchUpdateTree",
      PATCH_UPDATE_PROPERTY: "/patchUpdateProperty",

      // Punarcarshan - Section 19
      POST_PUNARVARSHAN: "/postAddPunarvarshan",
      PATCH_UPDATE_PUNARVARSHAN: "/patchUpdatePunarvarshan",
      DELETE_PUNARVARSHAN: "/punarvarshanId",

      //UnderSection21
      GET_CLAIMS_UNDER_SECTION21: "/getClaimsUnderSection21",
      POST_ADD_CLAIMS_UNDER_SECTION21: "/postAddClaimsUnderSection21",
      PATCH_UPDATE_CLAIMS_UNDER_SECTION21: "/patchUpdateClaimsUnderSection21",

      //UnderSection21
      GET_COVERING_LETTER: "/getCoveringLetter",
      POST_ADD_COVERING_LETTER: "/postAddUpdateCoveringLetter",

      //AdminSummary
      GET_PROPOSAL_TOTAL: "/getAssignProposalTotal",

      //  User Management
      POST_ADD_NEW_USER: "/postAddUser",
      POST_UPDATE_USER: "/patchUpdateUser",

      //Work Assign
      GET_WORK_ASSIGN: "/getWorkAssign",
      GET_NIVADA_CATEGORY: "/getNivadaCategory",
      //Teshsildar
      // Endpoints
      GET_LAND_REPORT_ACTIONS: "/getLandReportActions",
      GET_TEHSILDAR_RECORD: "/getTehsildarRecord",
      POST_ADD_UPDATE_TEHSILDAR_RECORD: "/postAddUpdateTehsildarRecord",

      //Document
      GET_DOCUMENTS: "/getDocuments",
      POST_ADD_UPDATE_OTHER_DOCUMENTS: "/postAddUpdateOtherDocuments",

      //FundRequestReceived
      GET_FUND_REQUEST_RECEIVED: "/getFundRequestReceived",
      POST_ADD_FUND_REQUEST_RECEIVED_SECTION11: "/postAddFundRequestReceived",
      POST_ADD_FUND_REQUEST_RECEIVED_SECTION19: "/postAddFundRequestReceived",
      PATCH_UPDATE_FUND_REQUEST_RECEIVED: "/patchUpdateFundRequestReceived",

      //FamilySurevy
      GET_FAMILY_DETAILS: "/getFamilyDetails",
      POST_FAMILY_DETAILS: "/postAddFamilyDetails",
      PATCH_FAMILY_DETAILS: "/patchUpdateFamilyDetails",

      POST_FAMILY_PROPERTY: "/postAddFamilyProperty",
      PATCH_UPDATE_FAMILY_PROPERTY: "/patchUpdateFamilyProperty",

      // Extend Date
      GET_PROPOSAL_EXTENDED_DATE: "/getExtendDate",
      POST_PROPOSAL_EXTENDED_DATE: "/postAddExtendDate",
      PATCH_PROPOSAL_EXTENDED_DATE: "/patchUpdateExtendDate",

      // SubUSers
      GET_SUB_USERS: "/getAllSubUsers",
      GET_SUMMARY: "/getAllProjectSummary",

      GET_MASTERPROJECT: "/getMasterAllProject",

      GET_LANDPLOTFAMILY: "/getLandPlotFamilyPublication",
      POST_ADD_UPDATE_LAND_PLOAT_FAMILY:
        "/postAddUpdateLandPlotFamilyPublication",

      // Notification
      GET_MASTER_PROJECT: "/getMasterAllProject",
      POST_PUBLICATION: "/postAddRecentPublication",
      GET_RECENT_PUBLICATION: "/getRecentPublication",
      UPDATE_RECENT_PUBLICATION: "patchUpdateRecentPublication",
      DELETE_RECENT_PUBLICATION: "deleteRecentPublication",

      GET_PUBLIC_DASHBOARD: "/getPublicDashboard",

      GET_CONTACT_DETAILS: "/getContactDetails",

      GET_PUNARVARSHAN: "/getLandPunarvarshan",
      POST_ADD_UPDATE_PUNARVARSHAN: "/postAddUpdateLandPunarvarshan",

      // Dashboard
      GET_TRACKING_PROPOSAL_FOR_DASHBOARD: "/getTrackingProposalForDashboard",
      GET_PROPOSALS_DASHBOARD: "/getProposalDashboard",
      GET_TRACKING_PROJECT_SECTION_COUNTS: "/getTrackingProjectSectionCounts",
      GET_TRACKING_PROJECT_SECTION_PROPOSALS:
        "/getTrackingProjectSectionProposals",

      POST_ADD_UPDATE_MASTER_MARKET_VALUE: "/postAddUpdateMasterMarketValue",
      // For Railway
      //Proposal
      ADD_RAILWAY_PROPOSAL: "/postAddRailwayProposal",
      GET__RAILWAY_PROPOSALS: "/getDashboardRailwayProposal",
      GET_RAILWAY_PROPOSAL_PUBLISH: "/getDashboardRailwayProposal",
      UPDATE_RAILWAY_PROPOSAL_PUBLISH: "/patchUpdateRailwayProposal",

      //Landholding
      POST_RAILWAY_ADD_LANDHOLDING: "/postAddRailwayLandHolding",
      GET_RAILWAY_LANDHOLDING: "/getRailwayLandHolding",
      DELETE_RAILWAY_LANDHOLDING: "/DeleteRailwayLandHolding",
      UPDATE_RAILWAY_LANDHOLDING: "/patchUpdateRailwayLandHolding",

      // Parishist A Notice
      GET_RAILWAY_PARISHIST_A_NOTICE: "/getRailwayParishishtANotice",
      POST_RAILWAY_ADD_UPDATE_PARISHIST_A_NOTICE:
        "/postAddUpdateRailwayParishistANotice",

      // E Work Details
      GET_RAILWAY_E_Work_Details: "/getRailwayEWorkDeatils",
      POST_RAILWAY_ADD_UPDATE_E_Work_Details:
        "/postAddUpdateRailwayEWorkDeatils",

      //Measurement
      ADD_RAILWAY_MEASUREMENT: "/postAddRailwayMeasurement",
      GET_RAILWAY_MEASUREMENT_OWNER_ID: "/getRailwayMeasurement",

      //Tracking
      POST_RAILWAY_TRACKING: "/postRailwayTracking",

      //Send Button
      GET_RAILWAY_BUTTON_DISABLE: "/getRailwaySendButton",

      //PAP
      GET_RAILWAY_PAP: "/getRailwayPAP",

      //For Highway
      //Proposal
      ADD_HIGHWAY_PROPOSAL: "/postAddHighwayProposal",
      GET_HIGHWAY_PROPOSALS: "/getDashboardHighwayProposal",
      UPDATE_HIGHWAY_PROPOSAL_PUBLISH: "/patchUpdateHighwayProposal",
      GET_HIGHWAY_PROPOSALS_PUBLISH: "/getDashboardHighwayProposal",

      //Landholding
      POST_HIGHWAY_ADD_LANDHOLDING: "/postAddHighwayLandHolding",
      GET_HIGHWAY_LANDHOLDING: "/getHighwayLandHolding",
      DELETE_HIGHWAY_LANDHOLDING: "/DeleteHighwayLandHolding",
      UPDATE_HIGHWAY_LANDHOLDING: "/patchUpdateHighwayLandHolding",

      //Measurement
      ADD_HIGHWAY_MEASUREMENT: "/postAddHighwayMeasurement",
      GET_HIGHWAY_MEASUREMENT: "/getHighwayMeasurement",
      GET_HIGHWAY_MEASUREMENT_BY_OWNER_ID: "/getHighwayMeasurement",
      GET_HIGHWAY_ALL_OWNER: "/getHighwayAllOwner",
      GET_HIGHWAY_PAP: "/getHighwayPAP",
      GET_HIGHWAY_AGENCY: "/getHighwayAgency",

      // Highway Tree
      GET_HIGHWAY_TREE: "/getHighwayTree",
      POST_ADD_HIGHWAY_TREE: "/postAddHighwayTree",
      PATCH_UPDATE_HIGHWAY_TREE: "/patchUpdateHighwayTree",

      // Highway Property
      GET_HIGHWAY_PROPERTY: "/getHighwayProperty",
      POST_ADD_HIGHWAY_PROPERTY: "/postAddHighwayProperty",
      PATCH_UPDATE_HIGHWAY_PROPERTY: "/patchUpdateHighwayProperty",

      // Highway Covering Letter
      GET_HIGHWAY_COVERING_LETTER: "/getHighwayCoveringLetter",
      POST_ADD_UPDATE_HIGHWAY_COVERING_LETTER:
        "/postAddUpdateHighwayCoveringLetter",

      //Highway Common
      GET_HIGHWAY_BUTTON_DISABLE: "/getHighwaySendButton",
      POST_HIGHWAY_TRACKING: "/postHighwayTracking",

      POST_LAND_PLOT_OBJECTION: "/postAddLandPlotObjection",
      GET_LAND_OBJECTION: "/getLandPlotObjection",
      UPDATE_LAND_PLOT_OBJECTION: "/patchUpdateLandPlotObjection",
      GET_LAND_PLOT_FAMILY_PUBLICATION: "/getLandPlotFamilyPublication",
      GET_LAND_PLOT_OBJECTION_PUBLICATION: "/getLandPlotObjectionPublication",
      POST_ADD_UPDATE_LAND_PLOT_OBJECTION_PUBLICATION:
        "/postAddUpdateLandPlotObjectionPublication",

      GET_REHAB_A: "/getRehabA",
      POST_ADD_REHAB_A: "/postAddRehabA",
      PATCH_UPDATE_REHAB_A: "/patchUpdateRehabA",
      GET_TIPPANI: "/getTippani",
      POST_ADD_UPDATE_TIPPANI: "/postAddUpdateTippani",
      GET_LAND_ALLOCATION_REPORT: "/getLandAllocationReport",
      GET_TABAPAVTI: "/getTabapavti",
      GET_KJP_TABAPAVTI:"/getKJPTabapavti",
      POST_ADD_UPDATE_KJP_TABAPAVTI: "/postAddUpdateKJPTabapavti",
      POST_ADD_UPDATE_TABAPAVTI: "/postAddUpdateTabapavti",
      POST_ADD_UPDATE_TABAPAVTI_TIPPANI: "/postAddUpdateTabapavtiTippani",
      GET_TABAPAVTI_TIPPANI: "/getTabapavtiTippani",
      GET_ALL_SEARCH: "/getAllSearch",
      GET_ALL_DOCUMENTS: "/getAllDocuments",

      // Notification
      GET_NOTIFICATION: "/getNotifaction",
      PATCH_UPDATE_SINGLE_NOTIFICATION: "/patchUpdateSingleNotification",
      PATCH_UPDATE_ALL_NOTIFICATION: "/patchUpdateAllNotification",

      // Nivada
      GET_NIVADA: "/getNivada",
      GET_NIVADA_PROJECT: "/getNivadaProject",
      GET_NIVADA_DISTRICT: "/getNivadaDistrict",
      GET_NIVADA_TALUKA: "/getNivadaTaluka",
      GET_NIVADA_VILLAGE: "/getNivadaVillage",
      GET_NIVADA_DOCUMENT: "/getNivadaDocument",
      GET_NIVADA_DOC_TYPE: "/getNivadaDocType",
      GET_NIVADA_TOTAL_COUNT: "/getNivadaTotalCount",
      GET_NIVADA_OWNER: "/getNivadaOwner",
      GET_NIVADA_OFFICE: "/getNivadaOffice",

      //Delete
      DELETE_FAMILY_DETAILS: "/deleteFamilyDetails",
      DELETE_FAMILY_PROPERTY: "/deleteFamilyProperty",
    };
  }

  // Setup axios interceptors for handling auth tokens and errors
  setupInterceptors() {
    // Request interceptor - adds auth token if available
    this.api.interceptors.request.use(
      (config) => {
        const token = this.getToken();
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      },
      (error) => Promise.reject(error),
    );

    // Response interceptor - handle common errors like unauthorized
    this.api.interceptors.response.use(
      (response) => {
        // ZIP / binary responses ko as-it-is return karo
        if (
          response.config.responseType === "arraybuffer" ||
          response.headers?.["content-type"]?.includes("zip")
        ) {
          return response;
        }

        // Normal JSON APIs
        return response.data;
      },
      (error) => {
        if (error.response) {
          if (error.response.status === 401) {
            this.clearAuth();
          }

          const errorMessage =
            (error.response.data && error.response.data.message) ||
            `Error ${error.response.status}`;

          return Promise.reject(new Error(errorMessage));
        }
        return Promise.reject(error);
      },
    );
  }

  // Auth token management
  getToken() {
    return localStorage.getItem("authToken");
  }

  setToken(token) {
    localStorage.setItem("authToken", token);
  }

  clearAuth() {
    localStorage.removeItem("authToken");
    localStorage.removeItem("userData");
  }

  // Generic request methods
  async get(endpoint, params = {}) {
    return this.api.get(endpoint, { params });
  }

  async post(endpoint, data = {}) {
    return this.api.post(endpoint, data);
  }

  async patch(endpoint, data = {}) {
    return this.api.patch(endpoint, data);
  }

  async delete(endpoint, params = {}) {
    return this.api.delete(endpoint, { params });
  }

  async postFormData(endpoint, formData) {
    return this.api.post(endpoint, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  // Auth-specific methods
  // async login(credentials) {
  //   const response = await this.post(this.endpoints.LOGIN, credentials);
  //   if (response.token) {
  //     this.setToken(response.token);
  //   }
  //   return response;
  // }

  // async register(userData) {
  //   return this.post(this.endpoints.REGISTER, userData);
  // }

  async login(credentials) {
    const response = await apiService.post(this.endpoints.LOGIN, credentials);

    // ⛔ Do NOT set token if OTP is required
    if (response?.token) {
      apiService.setToken(response.token);
    }

    return response;
  }

  async verifyLoginOTP(payload) {
    const response = await apiService.post(
      this.endpoints.VERIFY_LOGIN_OTP,
      payload,
    );

    if (response?.token) {
      apiService.setToken(response.token);
    }

    return response;
  }

  async register(data) {
    return apiService.post(this.endpoints.REGISTER, data);
  }

  async logout() {
    await this.post(this.endpoints.LOGOUT, {});
    this.clearAuth();
    window.location.href = "/";
  }

  async getPunarvarshanDetails(projectId = null, proposalId = null) {
    if (projectId && proposalId) {
      return (
        await this.api.get(this.endpoints.GET_PUNARVARSHAN, {
          params: { projectId, proposalId },
        })
      ).data;
    } else {
      throw new Error("projectId and proposalId are required!");
    }
  }

  async postAddUpdateLandPunarvarshan(payload = {}) {
    return (
      await this.api.post(this.endpoints.POST_ADD_UPDATE_PUNARVARSHAN, payload)
    ).data;
  }

  // Dashboard
  async getTrackingProposalForDashboard(projectId, proposalId) {
    try {
      const response = await this.api.get(
        this.endpoints.GET_TRACKING_PROPOSAL_FOR_DASHBOARD,
        {
          params: { projectId, proposalId },
        },
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching tracking proposal:", error);
      throw error;
    }
  }
  async getTrackingProjectSectionCounts() {
    return this.get(`${this.endpoints.GET_TRACKING_PROJECT_SECTION_COUNTS}`);
  }
  async getTrackingProjectSectionProposals(section) {
    return this.get(
      `${this.endpoints.GET_TRACKING_PROJECT_SECTION_PROPOSALS}?section=${section}`,
    );
  }
  async getAllDashboardProposal() {
    return this.get(`${this.endpoints.GET_PROPOSALS_DASHBOARD}`);
  }

  // Profile-specific methods
  async getProfile() {
    return this.get(this.endpoints.GET_PROFILE);
  }
  async getSummary() {
    return this.get(this.endpoints.GET_SUMMARY);
  }
  async getAllmasterproject() {
    return this.get(this.endpoints.GET_MASTERPROJECT);
  }

  async updateProfile(profileData) {
    // Handle both regular JSON and FormData
    if (profileData instanceof FormData) {
      return this.patch(this.endpoints.UPDATE_PROFILE, profileData);
    }
    return this.patch(this.endpoints.UPDATE_PROFILE, profileData);
  }

  // Role Management methods
  async getAllAssignedRoles() {
    return this.get(this.endpoints.GET_ALL_ASSIGN_ROLE);
  }

  async searchUser(name) {
    return this.get(this.endpoints.SEARCH_USER, { name });
  }

  async getAllUserRoles() {
    return this.get(this.endpoints.GET_ALL_USER_ROLE);
  }

  async getAllProjects(projectId = null) {
    const cacheKey = `getAllProjects_${projectId || "all"}`;

    // Check cache first
    const cached = this.getFromCache(cacheKey);
    if (cached) {
      return cached;
    }

    // Make API call if not cached
    let response;
    if (projectId) {
      response = await this.get(this.endpoints.GET_ALL_PROJECT, { projectId });
    } else {
      response = await this.get(this.endpoints.GET_ALL_PROJECT);
    }

    // Store in cache
    this.setCache(cacheKey, response);
    return response;
  }

  async getAllProjectsBeforeLogin(
    projectId = null,
    division = "",
    legacy = "",
  ) {
    // Build params object, only including non-empty values
    const params = {};

    if (projectId) {
      params.masterProjectId = projectId;
    }
    if (division) {
      params.type = division;
    }
    if (legacy !== "") {
      params.legacy = legacy;
    }

    // Create cache key based on all parameters
    const cacheKey = `getAllProjects_${projectId || "all"}_${division}_${legacy}`;

    // Check cache first
    const cached = this.getFromCache(cacheKey);
    if (cached) {
      return cached;
    }

    // Make API call with params (only non-empty ones will be included)
    const response = await this.get(
      this.endpoints.GET_ALL_PROJECT_BEFORE_LOGIN,
      params,
    );

    // Store in cache
    this.setCache(cacheKey, response);
    return response;
  }
  async getAllProjectsafterhomepage(projectId = null, filters = {}) {
    const { category = "", division = "", legacy = "" } = filters;

    // Create cache key including filters
    const filterKey = `${category}_${division}_${legacy}`;
    const cacheKey = `getAllProjectsafterhomepage_${projectId || "all"}_${filterKey}`;

    // Check cache first
    const cached = this.getFromCache(cacheKey);
    if (cached) {
      return cached;
    }

    // FIX: Build query params object properly
    const queryParams = new URLSearchParams();

    if (projectId) {
      queryParams.append("projectId", projectId);
    }
    if (category) {
      queryParams.append("category", category);
    }
    if (division) {
      queryParams.append("type", division);
    }
    if (legacy !== "") {
      queryParams.append("legacy", legacy);
    }

    // FIX: Construct the full URL with query string
    const endpoint = projectId
      ? this.endpoints.GET_ALL_PROJECTS
      : this.endpoints.GET_USER_PROJECT;
    const queryString = queryParams.toString();
    const url = queryString ? `${endpoint}?${queryString}` : endpoint;

    // Make API call
    const response = await this.get(url);

    // Store in cache
    this.setCache(cacheKey, response);
    return response;
  }

  // Paginated version for homepage
  async getAllProjectsPaginate(currentPage = 1, perPage = 20) {
    const cacheKey = `getAllProjectsPaginate_${currentPage}_${perPage}`;

    // Check cache first
    const cached = this.getFromCache(cacheKey);
    if (cached) {
      return cached;
    }

    // Make API call if not cached
    const response = await this.get(this.endpoints.GET_ALL_PROJECTS_PAGINATE, {
      currentPage,
      perPage,
    });

    // Store in cache
    this.setCache(cacheKey, response);
    return response;
  }

  // Cache helper methods
  setCache(key, value) {
    this.cache.set(key, {
      data: value,
      timestamp: Date.now(),
    });
  }

  getFromCache(key) {
    const cached = this.cache.get(key);
    if (!cached) return null;

    // Check if cache is still valid
    if (Date.now() - cached.timestamp > this.cacheTimeout) {
      this.cache.delete(key);
      return null;
    }

    return cached.data;
  }

  clearCache(key = null) {
    if (key) {
      this.cache.delete(key);
    } else {
      this.cache.clear();
    }
  }

  async getprojectactivity(projectId) {
    try {
      if (!projectId) {
        throw new Error("Project ID is required");
      }

      // Return the full response object, not just .data
      const response = await this.api.get(this.endpoints.GET_TRACKING, {
        params: { projectId },
      });
      return response.data; // This should contain { status: 200, data: [...] }
    } catch (error) {
      console.error("Error fetching project activity:", error);
      throw error;
    }
  }

  async addAssignRole(roleData) {
    return this.post(this.endpoints.POST_ADD_ASSIGN_ROLE, roleData);
  }

  async addNewUser(userData) {
    return this.post(this.endpoints.POST_ADD_NEW_USER, userData);
  }

  async UpdateNewUser(updateUserId, userData) {
    return this.patch(
      `${this.endpoints.POST_UPDATE_USER}?userIdToUpdate=${updateUserId}`,
      userData,
    );
  }

  async getWorkAssign() {
    return this.get(this.endpoints.GET_WORK_ASSIGN);
  }

  //GetDocument
  async getDocuments(projectId, proposalId, type) {
    if (projectId && proposalId && type) {
      return this.get(this.endpoints.GET_DOCUMENTS, {
        projectId,
        proposalId,
        type,
      });
    } else {
      throw new Error("projectId, proposalId, and type are required!");
    }
  }

  async getAllUserProjectInchargeRole(role = 18) {
    return this.get(this.endpoints.GET_ALL_USER, { role });
  }

  async postAddUpdateOtherDocuments(formData) {
    return (
      await this.api.post(
        this.endpoints.POST_ADD_UPDATE_OTHER_DOCUMENTS,
        formData,
      )
    ).data;
  }
  // Project Management methods
  async updateProject(projectId, updatedData) {
    try {
      const formData = new FormData();

      formData.append("project_name", updatedData.project_name || "");
      formData.append("project_type", updatedData.project_type || "");
      formData.append("project_division", updatedData.project_division || "");
      formData.append(
        "land_acquisition_no",
        updatedData.land_acquisition_no || "",
      );
      formData.append("village_name", updatedData.village_name || "");
      formData.append("taluka_name", updatedData.taluka_name || "");
      formData.append("dist_name", updatedData.dist_name || "");
      formData.append("total_budget", updatedData.total_budget || "");
      formData.append(
        "administrative_order_no",
        updatedData.administrative_order_no || "",
      );
      formData.append(
        "acquisition_proposal_no",
        updatedData.acquisition_proposal_no || "",
      );
      formData.append("no_of_budharak", updatedData.no_of_budharak || "0");
      formData.append("isactive", updatedData.isactive ? "1" : "0");

      // Check if it's a File object
      const hasNewBanner = updatedData.project_banner instanceof File;
      const hasNewAdminDoc = updatedData.administrative instanceof File;
      const hasNewAcquisitionDoc = updatedData.acquisition instanceof File;
      const hasNewDocument = updatedData.document instanceof File;

      if (hasNewBanner) {
        formData.append("project_banner", updatedData.project_banner);
      }

      if (hasNewAdminDoc) {
        formData.append("administrative", updatedData.administrative);
      }

      if (hasNewAcquisitionDoc) {
        formData.append("acquisition", updatedData.acquisition);
      }

      if (hasNewDocument) {
        formData.append("documents1", updatedData.document);
      }

      // You can also pass explicit flags from the frontend
      if (updatedData.hasNewBanner && updatedData.project_banner) {
        formData.append("project_banner", updatedData.project_banner);
      }

      if (updatedData.hasNewAdminDoc && updatedData.administrative) {
        formData.append("administrative", updatedData.administrative);
      }

      if (updatedData.hasNewAcquisitionDoc && updatedData.acquisition) {
        formData.append("acquisition", updatedData.acquisition);
      }

      // Date fields
      if (updatedData.administrative_order_date) {
        formData.append(
          "administrative_order_date",
          updatedData.administrative_order_date,
        );
      }

      if (updatedData.acquisition_proposal_date) {
        formData.append(
          "acquisition_proposal_date",
          updatedData.acquisition_proposal_date,
        );
      }

      const response = await this.api.patch(
        `${this.endpoints.PATCH_UPDATE_PROJECT}?projectId=${projectId}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      return response;
    } catch (error) {
      console.error("Error updating project:", error);
      throw error;
    }
  }

  async postAddProject(newProjectData) {
    try {
      const formData = new FormData();

      // Required fields - fixed parameter names to match what's being passed from React component
      formData.append("project_name", newProjectData.projectName || "");
      formData.append("project_type", newProjectData.projectType || "");
      formData.append("project_division", newProjectData.projectDivision || "");
      formData.append(
        "project_incharge_usr_id",
        newProjectData.projectInchargeUsrId || "",
      );
      formData.append(
        "project_category",
        newProjectData.project_category || "",
      );

      if (newProjectData.document instanceof File) {
        formData.append("documents1", newProjectData.document);
      }

      const response = await this.api.post(
        this.endpoints.POST_ADD_PROJECT,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
      return response;
    } catch (error) {
      console.error("Error adding new project:", error);
      throw error;
    }
  }

  async getAllUser() {
    return this.get(this.endpoints.GET_ALL_USER);
  }

  //AdminSummary
  async getProposalTotal(projectId) {
    try {
      if (!projectId) {
        throw new Error("Project ID is required");
      }

      const response = await this.api.get(this.endpoints.GET_PROPOSAL_TOTAL, {
        params: { projectId },
      });

      // API interceptor already extracts .data, so response should be { status, data }
      return response;
    } catch (error) {
      console.error("Error fetching proposal total:", error);
      throw error;
    }
  }

  // Land Type methods
  async getLandTypes() {
    return this.get(this.endpoints.GET_LAND_TYPE);
  }

  async addLandType(landTypeData) {
    return this.post(this.endpoints.POST_ADD_LAND_TYPE, landTypeData);
  }

  async updateLandType(landId, landTypeData) {
    return this.patch(
      `${this.endpoints.PATCH_UPDATE_LAND_TYPE}?landId=${landId}`,
      landTypeData,
    );
  }

  async deleteLandType(landId) {
    return this.delete(`${this.endpoints.DELETE_LAND_TYPE}?landId=${landId}`);
  }

  // Land Rate methods
  async getLandRates() {
    return this.get(this.endpoints.GET_LAND_RATE);
  }

  // Area Unit methods
  async getAreaUnits() {
    return this.get(this.endpoints.GET_AREA_UNIT);
  }

  async addAreaUnit(formData) {
    return this.post(this.endpoints.POST_ADD_AREA_UNIT, formData);
  }

  async updateAreaUnit(areaId, formData) {
    return this.patch(
      `${this.endpoints.PATCH_UPDATE_AREA_UNIT}?areaId=${areaId}`,
      formData,
    );
  }

  // Optional: Get single area unit by ID
  async getAreaUnitById(areaId) {
    return this.get(`${this.endpoints.GET_AREA_UNIT}?areaId=${areaId}`);
  }

  // Act methods
  async getActs() {
    return this.get(this.endpoints.GET_ACT);
  } 

  //MarketValue
  async getOwnerMarketValue(projectId, proposalId, locationParams = '') {
    try {
      let queryString = '';

      if (typeof locationParams === 'object' && locationParams !== null) {
        // Build query string from object
        const parts = [];
        if (locationParams.distName) parts.push(`distName=${encodeURIComponent(locationParams.distName)}`);
        if (locationParams.talukaName) parts.push(`talukaName=${encodeURIComponent(locationParams.talukaName)}`);
        if (locationParams.villName) parts.push(`villName=${encodeURIComponent(locationParams.villName)}`);
        if (locationParams.surveyNo) parts.push(`surveyNo=${encodeURIComponent(locationParams.surveyNo)}`);
        if (parts.length) queryString = '&' + parts.join('&');
      } else if (typeof locationParams === 'string') {
        // Already a string (used in MarketValueBail)
        queryString = locationParams;
      }

      const response = await this.api.get(
        `${this.endpoints.GET_OWNER_MARKET_VALUE}?projectId=${projectId}&proposalId=${proposalId}${queryString}`
      );
      return response;
    } catch (error) {
      console.error("API Error in getOwnerMarketValue:", error);
      throw error;
    }
  }

  async postAddUpdateOwnerMarketValue(projectId, proposalId, data) {
    try {
      const response = await this.api.post(
        `${this.endpoints.POST_ADD_UPDATE_OWNER_MARKET_VALUE}`,
        data,
      );
      return response;
    } catch (error) {
      console.error("API Error in postAddUpdateOwnerMarketValue:", error);
      throw error;
    }
  }
  async postAddUpdateMasterMarketValue(valueId, data) {
    try {
      const response = await this.api.post(
        `${this.endpoints.POST_ADD_UPDATE_MASTER_MARKET_VALUE}?value_id=${valueId}`,
        data,
      );
      return response;
    } catch (error) {
      console.error("API Error in postAddUpdateMasterMarketValue:", error);
      throw error;
    }
  }

  //Objection
  async postAddGeneralObjection(formDataOrDataObject, fileParam = null) {
    try {
      let finalFormData;

      // Check if the input is already a FormData object (new approach)
      // or a plain object (old approach)
      if (formDataOrDataObject instanceof FormData) {
        // New approach: FormData is already prepared by the calling function
        finalFormData = formDataOrDataObject;
      } else {
        // Old approach: Build FormData from data object and separate file
        const data = formDataOrDataObject;
        const file = fileParam;

        finalFormData = new FormData();

        // Map the data fields correctly
        finalFormData.append("project_id", data.projectId || data.project_id);
        finalFormData.append(
          "objection_date",
          data.objectionDate || data.objection_date,
        );
        finalFormData.append(
          "objection_no",
          data.objectionNo || data.objection_no || "OBJ-2024-001",
        );
        finalFormData.append(
          "objector_name",
          data.objectorName || data.objector_name,
        );
        finalFormData.append(
          "objector_contact",
          data.objectorContact || data.objector_contact,
        );
        finalFormData.append(
          "objector_email",
          data.objectorEmail || data.objector_email,
        );
        finalFormData.append(
          "objector_address",
          data.objectorAddress || data.objector_address,
        );
        finalFormData.append(
          "objector_type",
          data.objectorType || data.objector_type || "Individual",
        );

        // Identity proof fields
        finalFormData.append(
          "identity_proof_type",
          data.identityProofType || data.identity_proof_type || "",
        );
        finalFormData.append(
          "identity_proof_no",
          data.identityProofNo || data.identity_proof_no || "",
        );

        // Location fields
        finalFormData.append(
          "affected_survey_no",
          data.affectedSurveyNo || data.affected_survey_no,
        );
        finalFormData.append(
          "village_name",
          data.affectedVillage || data.village_name,
        );
        finalFormData.append(
          "taluka_name",
          data.affectedTaluka || data.taluka_name,
        );
        finalFormData.append(
          "dist_name",
          data.affectedDistrict || data.dist_name,
        );

        // Objection details
        finalFormData.append(
          "objection_category",
          data.objectionCategory || data.objection_category,
        );
        finalFormData.append(
          "objection_summary",
          data.objectionSummary || data.objection_summary,
        );
        finalFormData.append(
          "objection_details",
          data.objectionDetails || data.objection_details,
        );

        // Objection type flags
        // finalFormData.append('objection_compensation', (data.objectionCompensation || data.objection_compensation || false).toString());
        // finalFormData.append('objection_measurement', (data.objectionMeasurement || data.objection_measurement || false).toString());
        // finalFormData.append('objection_trees', (data.objectionTrees || data.objection_trees || false).toString());
        // finalFormData.append('objection_structures', (data.objectionStructures || data.objection_structures || false).toString());
        // finalFormData.append('objection_crops', (data.objectionCrops || data.objection_crops || false).toString());
        // finalFormData.append('objection_water_bodies', (data.objectionWaterBodies || data.objection_water_bodies || false).toString());
        // finalFormData.append('objection_title', (data.objectionTitle || data.objection_title || false).toString());
        // finalFormData.append('objection_livelihood', (data.objectionLivelihood || data.objection_livelihood || false).toString());
        // finalFormData.append('objection_payment', (data.objectionPayment || data.objection_payment || false).toString());
        finalFormData.append(
          "objection_other",
          data.objectionOther || data.objection_other || "",
        );

        // Measurement details
        if (data.recordedArea || data.recorded_area) {
          finalFormData.append(
            "recorded_area",
            data.recordedArea || data.recorded_area,
          );
        }
        if (data.claimedArea || data.claimed_area) {
          finalFormData.append(
            "claimed_area",
            data.claimedArea || data.claimed_area,
          );
        }
        // finalFormData.append('area_unit', data.areaUnit || data.area_unit || 'sqm');

        // Compensation details
        if (data.recordedCompensation || data.recorded_compensation) {
          finalFormData.append(
            "recorded_compensation",
            data.recordedCompensation || data.recorded_compensation,
          );
        }
        if (data.expectedCompensation || data.expected_compensation) {
          finalFormData.append(
            "expected_compensation",
            data.expectedCompensation || data.expected_compensation,
          );
        }

        // Tree details
        if (data.numTreesRecorded || data.num_trees_recorded) {
          finalFormData.append(
            "num_trees_recorded",
            data.numTreesRecorded || data.num_trees_recorded,
          );
        }
        if (data.numTreesClaimed || data.num_trees_claimed) {
          finalFormData.append(
            "num_trees_claimed",
            data.numTreesClaimed || data.num_trees_claimed,
          );
        }
        if (data.treeDetails || data.tree_details) {
          finalFormData.append(
            "tree_details",
            data.treeDetails || data.tree_details,
          );
        }

        // System fields
        finalFormData.append(
          "supporting_documents",
          (
            data.supportingDocuments ||
            data.supporting_documents ||
            true
          ).toString(),
        );
        finalFormData.append(
          "document_references",
          data.documentReferences || data.document_references || "",
        );
        finalFormData.append(
          "OBJECTION_STATUS",
          data.objectionStatus || data.objection_status || "Pending",
        );
        finalFormData.append(
          "hearing_required",
          (data.hearingRequired || data.hearing_required || true).toString(),
        );
        // finalFormData.append('submission_timestamp', data.submissionTimestamp || data.submission_timestamp || new Date().toISOString());

        // Default hearing details (can be updated later)
        finalFormData.append(
          "hearing_date",
          data.hearingDate || data.hearing_date || "2024-12-10T11:00:00",
        );
        finalFormData.append(
          "hearing_venue",
          data.hearingVenue || data.hearing_venue || "Tehsildar Office, Haveli",
        );
        finalFormData.append(
          "hearing_officer",
          data.hearingOfficer || data.hearing_officer || "Mr. Suresh Kadam",
        );

        // Handle file attachment (support both parameter approaches)
        if (file) {
          finalFormData.append("identityProof", file);
        }
      }

      // If FormData was pre-built, check if it needs the file field name adjustment
      if (formDataOrDataObject instanceof FormData) {
        // Check if identity_proof_file exists and rename it to identityProof for backend compatibility
        let identityFile = null;
        let hasIdentityProofFile = false;

        // Check what file fields exist in the FormData
        for (let pair of finalFormData.entries()) {
          if (pair[0] === "identity_proof_file" && pair[1] instanceof File) {
            identityFile = pair[1];
            hasIdentityProofFile = true;
            break;
          }
        }

        // If identity_proof_file exists, remove it and add as identityProof
        if (hasIdentityProofFile && identityFile) {
          // Create a new FormData to rebuild with correct field name
          const newFormData = new FormData();

          // Copy all fields except identity_proof_file
          for (let pair of finalFormData.entries()) {
            if (pair[0] !== "identity_proof_file") {
              newFormData.append(pair[0], pair[1]);
            }
          }

          // Add the file with correct field name
          newFormData.append("identityProof", identityFile);
          finalFormData = newFormData;
        }
      }

      const response = await this.api.post(
        this.endpoints.POST_ADD_GENERAL_OBJECTION,
        finalFormData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          // Add timeout and other configurations
          timeout: 30000, // 30 seconds timeout
          maxContentLength: Infinity,
          maxBodyLength: Infinity,
        },
      );

      return response.data;
    } catch (error) {
      console.error("🌐 API Service: Upload process failed", error);

      // Enhanced error logging
      if (error.response) {
        console.error(
          "🌐 API Service: Response Error Status:",
          error.response.status,
        );
        console.error(
          "🌐 API Service: Response Error Data:",
          error.response.data,
        );
        console.error(
          "🌐 API Service: Response Error Headers:",
          error.response.headers,
        );
      } else if (error.request) {
        console.error("🌐 API Service: Request Error:", error.request);
        console.error("🌐 API Service: No response received from server");
      } else {
        console.error("🌐 API Service: General Error:", error.message);
      }

      // Throw a more descriptive error
      const errorMessage =
        error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        "Upload process failed";
      const enhancedError = new Error(errorMessage);
      enhancedError.status = error.response?.status;
      enhancedError.response = error.response;

      throw enhancedError;
    }
  }

  async getAllGeneralObjections(projectId = null, proposalId = null) {
    if (projectId && proposalId) {
      return (
        await this.api.get(this.endpoints.GET_GENERAL_OBJECTIONS, {
          params: { projectId, proposalId },
        })
      ).data;
    } else {
      throw new Error("projectId and proposalId are required!");
    }
  }

  async getAllPrivateObjections(projectId = null, proposalId = null) {
    if (projectId && proposalId) {
      return (
        await this.api.get(this.endpoints.GET_PRIVATE_OBJECTIONS, {
          params: { projectId, proposalId },
        })
      ).data;
    } else {
      throw new Error("projectId and proposalId are required!");
    }
  }

  async getGeneralObjectionById(objId) {
    try {
      const response = await this.api.get(
        `${this.endpoints.GET_GENERAL_OBJECTIONS}?objId=${objId}`,
      );
      return response.data;
    } catch (error) {
      console.error("API Error in getGeneralObjectionById:", error);
      throw error;
    }
  }

  //update general objection:
  async patchUpdateGeneralObjection(objId, objectionData = {}) {
    try {
      if (!objectionData || typeof objectionData !== "object") {
        throw new Error("patchUpdateGeneralObjection: Invalid objectionData");
      }

      const formData = new FormData();
      Object.entries(objectionData).forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
          formData.append(key, value);
        }
      });

      const response = await this.api.patch(
        "/patchUpdateGeneralObjection",
        formData,
        { params: { objId: objId } },
      );

      return { status: response.status, data: response.data };
    } catch (error) {
      console.error("❌ Update General Objection Error:", error);
      throw error;
    }
  }

  //Send OTP
  // async getSendEmailOtpObjection(email) {
  //   try {
  //     const response = await this.api.get(`${this.endpoints.SEND_EMAIL_OTP_OBJECTION}?email=${encodeURIComponent(email)}`);

  //     // Store token if received
  //     if (response.data && response.data.token) {
  //       this.setToken(response.data.token);
  //     }

  //     return response.data;
  //   } catch (error) {
  //     console.error('🌐 API Service: Send OTP Email error:', error);
  //     console.error('🌐 API Service: Error Details:', {
  //       message: error.message,
  //       response: error.response,
  //       responseData: error.response?.data,
  //       status: error.response?.status
  //     });
  //     throw error;
  //   }
  // }

  async getSendEmailOtpObjection(email) {
    try {
      const response = await this.api.get(
        `${this.endpoints.SEND_EMAIL_OTP_OBJECTION}?email=${encodeURIComponent(email)}`,
      );

      // Return the response data - let the calling function handle token storage
      const apiResponse = response.data || response;

      // ✅ Log if token is present but don't store it here (let handleSubmit do it)
      if (apiResponse && apiResponse.otpToken) {
      } else {
        console.warn("🌐 API Service: No otpToken found in response");
      }

      return apiResponse;
    } catch (error) {
      console.error("🌐 API Service: Send OTP Email error:", error);
      console.error("🌐 API Service: Error Details:", {
        message: error.message,
        response: error.response,
        responseData: error.response?.data,
        status: error.response?.status,
      });
      throw error;
    }
  }

  //Objection Section15
  async postTrackingSamanvayObjection(data, type = "ObjectionSamanvay") {
    const url = `${this.endpoints.POST_TRACKING}?type=${type}`;
    return this.post(url, data);
  }
   async postTrackingSamanvayFinalObjection(data, type = "SamanvayFinalObjection") {
    const url = `${this.endpoints.POST_TRACKING}?type=${type}`;
    return this.post(url, data);
  }


  //postTracking?type=ObjectionCollector
  async postTrackingCollectorObjection(data, type = "ObjectionCollector") {
    const url = `${this.endpoints.POST_TRACKING}?type=${type}`;
    return this.post(url, data);
  }

  //postTracking?type=ObjectionLAO
  async postTrackingLAOObjection(data, type = "ObjectionLAO") {
    const url = `${this.endpoints.POST_TRACKING}?type=${type}`;
    return this.post(url, data);
  }

  //postTracking?type=ProjectInchargeFundSection11
  async postTrackingSendToProjectIncharge(
    data,
    type = "ProjectInchargeFundSection11",
  ) {
    const url = `${this.endpoints.POST_TRACKING}?type=${type}`;
    return this.post(url, data);
  }

  //postTracking?type=LAOFundSection11
  async postTrackingSendBackToLAO(data, type = "LAOFundSection11") {
    const url = `${this.endpoints.POST_TRACKING}?type=${type}`;
    return this.post(url, data);
  }

  // Send to Tehsildar
  async postTrackingSendToTehsildarLand(data, type = "LandParuptTehsildar") {
    const url = `${this.endpoints.POST_TRACKING}?type=${type}`;
    return this.post(url, data);
  }

  //postTracking?type=ProjectInchargeFundSection11
  async postTrackingSendToProjectInchargeLand(
    data,
    type = "LandParuptProjectIncharge",
  ) {
    const url = `${this.endpoints.POST_TRACKING}?type=${type}`;
    return this.post(url, data);
  }

  //Send to DRO
  async postTrackingSendToDRO(data, type = "NamunaADRO") {
    const url = `${this.endpoints.POST_TRACKING}?type=${type}`;
    return this.post(url, data);
  }

  // ✅ Use query params (or Axios "params") instead of FormData
  async getClaimsUnderSection21(projectId, proposalId) {
    try {
      const response = await this.api.get(
        this.endpoints.GET_CLAIMS_UNDER_SECTION21,
        {
          params: {
            projectId: projectId,
            proposalId: proposalId,
          },
        },
      );
      return response; // response.data is handled in component
    } catch (error) {
      console.error("API Error in getClaimsUnderSection21:", error);
      throw error;
    }
  }

  async postAddClaimsUnderSection21(formData) {
    try {
      const response = await this.api.post(
        this.endpoints.POST_ADD_CLAIMS_UNDER_SECTION21,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } },
      );
      return response;
    } catch (error) {
      console.error("API Error in postAddClaimsUnderSection21:", error);
      throw error;
    }
  }

  async patchUpdateClaimsUnderSection21(claimantId, formData) {
    return this.api.patch(
      `${this.endpoints.PATCH_UPDATE_CLAIMS_UNDER_SECTION21}?claimantId=${claimantId}`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } },
    );
  }

  //For get Objection
  async getSendToSamanvayObjectionButton(
    projectId,
    proposalId,
    type = "ObjectionSamanvay",
  ) {
    const url = `${this.endpoints.GET_BUTTON_DISABLE}?project_id=${projectId}&proposal_id=${proposalId}&type=${type}`;
    return this.get(url);
  }
   async getSendbutton(
    projectId,
    proposalId,
    type,
  ) {
    const url = `${this.endpoints.GET_BUTTON_DISABLE}?project_id=${projectId}&proposal_id=${proposalId}&type=${type}`;
    return this.get(url);
  }

  async postObjectionOtpVerify(email, otp, otpToken) {
    try {
      // ✅ FIXED: Send all parameters in URL as requested
      const url = `${this.endpoints.VERIFY_OBJECTION_OTP}?email=${encodeURIComponent(email)}&otp=${otp}&otpToken=${encodeURIComponent(otpToken)}`;

      const response = await this.api.post(url);

      return response.status;
    } catch (error) {
      console.error("🌐 API Service: OTP Verification error:", error);

      // Enhanced error logging
      if (error.response) {
        console.error(
          "🌐 API Service: Error Response Status:",
          error.response.status,
        );
        console.error(
          "🌐 API Service: Error Response Data:",
          error.response.data,
        );
      }

      throw error;
    }
  }

  async getLandHolding(projectId = null, locationParams = {}) {
    try {
      const params = {};

      // Add projectId if provided
      if (projectId) {
        params.projectId = projectId;
      }
      // Add proposalId if provided
      if (locationParams.proposalId) {
        params.proposalId = locationParams.proposalId;
      }

      // Add location parameters if provided
      if (locationParams.distNo) {
        params.distNo = locationParams.distNo;
      }
      if (locationParams.talukaNo) {
        params.talukaNo = locationParams.talukaNo;
      }
      if (locationParams.villageNo) {
        params.villageNo = locationParams.villageNo;
      }

      return this.get(this.endpoints.GET_LANDHOLDING, params);
    } catch (error) {
      console.error("Error in getLandHolding:", error);
      throw error;
    }
  }

  async getLandHoldingById(landId) {
    try {
      const response = await this.api.get(
        `${this.endpoints.GET_LANDHOLDING}?landId=${landId}`,
      );
      return response; // instead of response.data
    } catch (error) {
      console.error("API Error in getGeneralObjectionById:", error);
      throw error;
    }
  }

  async updateLandHolding(landId, data) {
    try {
      // Validate landId before making the API call
      if (!landId || landId === "undefined" || landId === undefined) {
        throw new Error("Invalid landId provided for update operation");
      }

      const response = await this.patch(
        `${this.endpoints.GET_UPDATE_LANDHOLDING}?landId=${landId}`,
        data,
      );

      // Check if response is ok
      if (response.status !== 200 && response.status !== 204) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
      const result = response.data;

      return {
        ok: true,
        data: result,
        status: response.status,
      };
    } catch (error) {
      console.error("Error updating land holding:", error);
      console.error("LandId:", landId);
      console.error("Data:", data);

      // Re-throw with more descriptive error
      throw new Error(`Failed to update landholding: ${error.message}`);
    }
  }

  async postAddLandHolding(data) {
    const payload = {
      project_id: data.projectId || data.project_id,
      proposal_id: data.proposalId || data.proposal_id,
      village_name: data.village_name,
      // district_id: data.district_id,     // Add this line
      // taluka_id: data.taluka_id,         // Add this line
      survey_no: data.surveyNo || data.survey_no,
      aqr_area: data.aqrArea || data.aqr_area,
      area_unit_id: data.areaUnitId || data.area_unit_id || "ACRE",
      landholder_name: data.landholderName || data.landholder_name,
      survey_type: data.surveyType || data.survey_type || "Revenue",
      irrigable_type: data.irrigableType || data.irrigable_type,
      irrigable_area: data.irrigableArea || data.irrigable_area,
      non_irrigable_area: data.nonIrrigableArea || data.non_irrigable_area,
      construction_area: data.construction_area,
      total_area: data.totalArea || data.total_area,
      north: data.north || data.north,
      east: data.east || data.east,
      west: data.west || data.west,
      south: data.south || data.south,
      is_active:
        data.isActive !== undefined
          ? data.isActive
          : data.is_active !== undefined
            ? data.is_active
            : 1,
      land_no: data.landNo || data.land_no,
      // Add the District_no and taluka_no fields that your backend expects
      dist_name: data.dist_name,
      taluka_name: data.taluka_name,
      land_holding_type: data.land_holding_type,
      latitude: data.latitude,
      longitude: data.longitude,
      total_7_12_area: data.totalArea_7_12,
    };

    if (data.common_area) {
      payload.common_area = data.common_area;
    }

    try {
      const response = await this.api.post(
        this.endpoints.POST_ADD_LANDHOLDING,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      return response;
    } catch (error) {
      console.error("Add landholding failed", error);
      console.error("Error details:", error.response?.data || error.message);
      throw error;
    }
  }

  // Land Holding Types
  async getLandHoldingType() {
    return this.get(this.endpoints.GET_LANDHOLDING_Type);
  }

  async deleteLandHolding(landId) {
    return this.delete(`${this.endpoints.DELETE_LANDHOLDING}?landId=${landId}`);
  }

  async getDistricts() {
    try {
      const response = await this.get(this.endpoints.GET_DISTRICTS);
      return response;
    } catch (error) {
      console.error("Error fetching districts:", error);
      throw new Error("Failed to fetch districts");
    }
  }

  async getTalukas(distNo) {
    try {
      if (!distNo) {
        throw new Error("District number is required");
      }

      const response = await this.get(this.endpoints.GET_TALUKAS, { distNo });
      return response;
    } catch (error) {
      console.error("Error fetching talukas:", error);
      throw new Error("Failed to fetch talukas");
    }
  }
  async getVillages(distNo = null, tehsil_no = null) {
    try {
      const params = {};

      if (distNo && tehsil_no) {
        params.distNo = distNo;
        params.tehsil_no = tehsil_no;
      }

      const response = await this.get(this.endpoints.GET_VILLAGE, params);
      return response;
    } catch (error) {
      console.error("Error fetching villages:", error);
      throw new Error("Failed to fetch villages");
    }
  }

  // Forgot Password methods
  async requestPasswordReset(email) {
    return this.post(
      `${this.endpoints.PASSWORD_EMAIL}?email=${encodeURIComponent(email)}`,
    );
  }

  async verifyPasswordOTP(email, otp) {
    return this.post(
      `${this.endpoints.PASSWORD_EMAIL_OTP}?email=${encodeURIComponent(email)}&otp=${otp}`,
    );
  }

  async resetPassword(email, newPassword, confirmPassword) {
    return this.post(
      `${this.endpoints.FORGOT_PASSWORD}?email=${encodeURIComponent(email)}`,
      {
        newPassword,
        confirmPassword,
      },
    );
  }

  // Village Management methods
  // async getAllVillages(projectId = null) {
  //   return this.get(`${this.endpoints.GET_ALL_VILLAGE}?projectId=${projectId}`);
  // }

  async getAllVillages() {
    return this.get(this.endpoints.GET_ALL_VILLAGE);
  }

  async updateVillageActivity(villId) {
    return this.patch(
      `${this.endpoints.PATCH_VILLAGE_ISACTIVE}?villId=${villId}`,
    );
  }

  //Mesurement List
  async getAllOwner(
    districtName = null,
    talukaName = null,
    villageName = null,
    projectId = null,
    proposalId = null,
  ) {
    try {
      if (!projectId && !proposalId) {
        throw new Error("At least projectId or proposalId must be provided");
      }

      const params = {};
      if (districtName) params.districtName = districtName;
      if (talukaName) params.talukaName = talukaName;
      if (villageName) params.villageName = villageName;
      if (projectId) params.projectId = projectId;
      if (proposalId) params.proposalId = proposalId;

      // Use axios directly to get full response
      const response = await axios.get(
        `${this.api.defaults.baseURL}/getAllOwner`,
        {
          params,
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
            ...this.api.defaults.headers,
          },
        },
      );

      return {
        status: response.status,
        data: response.data.landAcquisition || [],
      };
    } catch (error) {
      console.error("Error in getAllOwner API:", error);
      throw error;
    }
  }

  async getMeasurement(
    districtName = null,
    talukaName = null,
    villageName = null,
    projectId = null,
    locationParams = {},
  ) {
    try {
      if (!projectId && !locationParams.proposalId) {
        throw new Error("At least projectId or proposalId must be provided");
      }

      const params = {};
      if (districtName) params.districtName = districtName;
      if (talukaName) params.talukaName = talukaName;
      if (villageName) params.villageName = villageName;
      if (projectId) params.projectId = projectId;
      if (locationParams.proposalId)
        params.proposalId = locationParams.proposalId;

      const response = await this.api.get("/getMeasurement", { params });

      return {
        status: response.status,
        data: response.data,
      };
    } catch (error) {
      console.error("Error fetching measurements:", error);
      throw new Error("Failed to fetch measurements");
    }
  }

  async getMeasurementByLandId(landAcquisitionId) {
    try {
      if (!landAcquisitionId) {
        throw new Error("Land Acquisition ID is required");
      }

      const params = {
        landAcquisitionId,
      };

      const response = await this.api.get("/getMeasurement", { params });

      // The API seems to return the data directly as an array
      return {
        status: response.status,
        data: response.data,
        landAcquisition: response.landAcquisition,
      };
    } catch (error) {
      console.error("Error fetching measurement by land ID:", error);

      if (error.response) {
        console.error(
          "Server Error:",
          error.response.status,
          error.response.data,
        );
      } else if (error.request) {
        console.error("Network Error:", error.request);
      } else {
        console.error("Request Setup Error:", error.message);
      }

      throw new Error(`Failed to fetch measurement data: ${error.message}`);
    }
  }

  async getMeasurementByOwnerID(measurementId) {
    try {
      const response = await this.api.get(
        this.endpoints.GET_MEASUREMENT_OWNER_ID,
        {
          params: { measurementId },
        },
      );
      return response.data; // Returns { status: 200, data: {...} }
    } catch (error) {
      console.error("Error in getMeasurementByOwnerID:", error);
      throw error;
    }
  }

  // async getMeasurementByOwnerID(measurementId) {
  //   try {
  //     const response = await this.api.get(this.endpoints.GET_MEASUREMENT_OWNER_ID, {
  //       params: { measurementId }
  //     });
  //     return response.data; // Returns { status: 200, data: {...} }
  //   } catch (error) {
  //     console.error('Error in getMeasurementByOwnerID:', error);
  //     throw error;
  //   }
  // }

  async getMeasurementForImage(measurementId) {
    try {
      const response = await this.api.get("/getMeasurement", {
        params: { measurementId },
      });
      return response.data; // Returns { status: 200, data: [...] }
    } catch (error) {
      console.error("Error in getMeasurementForImage:", error);
      throw error;
    }
  }

  async patchUpdateMeasurement(measurementId, measurementData) {
    try {
      const formData = new FormData();

      // Add all fields to FormData
      Object.entries(measurementData).forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
          formData.append(key, value);
        }
      });

      // ✅ Important: send measurementId as a query param named exactly 'measureId'
      const response = await this.api.patch(
        "/patchUpdateMeasurement",
        formData,
        {
          params: { measureId: measurementId }, // <-- correct!
        },
      );

      return {
        status: response.status,
        data: response.data,
      };
    } catch (error) {
      console.error("❌ Update Measurement Error:", error);
      throw error;
    }
  }

  async patchUpdateLand(landAcqId, measurementData) {
    try {
      const formData = new FormData();

      // Add all fields to FormData
      Object.entries(measurementData).forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
          formData.append(key, value);
        }
      });

      // ✅ Important: send measurementId as a query param named exactly 'measureId'
      const response = await this.api.patch(
        "/patchUpdateMeasurement",
        formData,
        {
          params: { landAcqId: landAcqId }, // <-- correct!
        },
      );

      return {
        status: response.status,
        data: response.data,
      };
    } catch (error) {
      console.error("❌ Update Measurement Error:", error);
      throw error;
    }
  }

  async patchUpdateLandHolding(landId, landHoldingData) {
    try {
      // Validate required parameters
      if (!landId) {
        throw new Error("Land ID is required");
      }

      if (!landHoldingData || typeof landHoldingData !== "object") {
        throw new Error("Land holding data is required and must be an object");
      }

      // Prepare the URL with query parameter
      const url = `${this.endpoints.PATCH_UPDATE_LAND_HOLDING}?landId=${landId}`;

      // Make the PATCH request
      const response = await this.api.patch(url, landHoldingData, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.getToken()}`, // Add auth token if required
        },
      });
      return response;
    } catch (error) {
      // Enhanced error handling
      console.error("Error updating land holding:", error);
      if (error.response) {
        // Server responded with error status
        const errorMessage =
          error.response.data?.message || "Server error occurred";
        const errorStatus = error.response.status;

        throw new Error(
          `Failed to update land holding: ${errorMessage} (Status: ${errorStatus})`,
        );
      } else if (error.request) {
        // Request was made but no response received
        throw new Error(
          "No response received from server. Please check your connection.",
        );
      } else {
        // Something else happened
        throw new Error(`Request failed: ${error.message}`);
      }
    }
  }

  //Add Measurement
  async addMeasurement(measurementData) {
    try {
      const response = await this.api.post(
        this.endpoints.ADD_MEASUREMENT,
        measurementData, // Pass the FormData here
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      return response;
    } catch (error) {
      if (error.name === "TypeError" && error.message.includes("fetch")) {
        throw new Error("Network error: Unable to connect to server");
      }
      throw error;
    }
  }

  // Hearing Management methods
  async createHearing(formData) {
    return this.post(this.endpoints.POST_HEARING, formData);
  }
  async getHearing(objId, objType) {
    const params = new URLSearchParams({
      objId: objId,
      objType: objType,
    });

    return this.get(`${this.endpoints.GET_HEARING}?${params.toString()}`);
  }

  async sendHearingNoticeMail(objId, objType, noticeFile) {
    const formData = new FormData();
    formData.append("notice", noticeFile);

    const endpoint = `${this.endpoints.SEND_HEARING_NOTICE_MAIL}?objId=${objId}&objType=${objType}`;
    return this.postFormData(endpoint, formData);
  }

  // Report
  async getStagewiseProject(projectId) {
    try {
      if (!projectId) {
        throw new Error("Project ID is required");
      }

      const response = await this.get(this.endpoints.GET_STAGEWISE_PROJECT, {
        projectId,
      });

      // Handle different response structures
      if (response && response.status === 200) {
        return response;
      } else if (response && Array.isArray(response.data)) {
        // If data is directly an array
        return {
          status: 200,
          data: response.data,
        };
      } else if (response && Array.isArray(response)) {
        // If response is directly an array
        return {
          status: 200,
          data: response,
        };
      }

      return response;
    } catch (error) {
      console.error("Error fetching stagewise project:", error);

      // Log detailed error information
      if (error.response) {
        console.error(
          "Server Error:",
          error.response.status,
          error.response.data,
        );
      } else if (error.request) {
        console.error("Network Error:", error.request);
      } else {
        console.error("Request Setup Error:", error.message);
      }

      throw new Error(
        `Failed to fetch stagewise project data: ${error.message}`,
      );
    }
  }

  //For Assign surveyor
  async getAssignSurveyorButton(projectId, proposalId, type = "Surveyor") {
    const url = `${this.endpoints.GET_BUTTON_DISABLE}?project_id=${projectId}&proposal_id=${proposalId}&type=${type}`;
    return this.get(url);
  }

  //For Assign back  to dslr
  async getAssignBackToDSLRButton(projectId, proposalId, type = "SLRV") {
    const url = `${this.endpoints.GET_BUTTON_DISABLE}?project_id=${projectId}&proposal_id=${proposalId}&type=${type}`;
    return this.get(url);
  }

  //For send back to LAO
  async getSendBackToLAOButton(projectId, proposalId, type = "LAOV") {
    const url = `${this.endpoints.GET_BUTTON_DISABLE}?project_id=${projectId}&proposal_id=${proposalId}&type=${type}`;
    return this.get(url);
  }

  // for compensation tracking
  async getCompensationButton(projectId, proposalId, type = "Compensation") {
    const url = `${this.endpoints.GET_BUTTON_DISABLE}?project_id=${projectId}&proposal_id=${proposalId}&type=${type}`;
    return this.get(url);
  }

  // for agency tracking
  async getAgencyButton(projectId, proposalId, type = "Agency") {
    const url = `${this.endpoints.GET_BUTTON_DISABLE}?project_id=${projectId}&proposal_id=${proposalId}&type=${type}`;
    return this.get(url);
  }
  // for final award tracking
  async getFinalAwardButton(projectId, proposalId, type = "finalAward") {
    const url = `${this.endpoints.GET_BUTTON_DISABLE}?project_id=${projectId}&proposal_id=${proposalId}&type=${type}`;
    return this.get(url);
  }

  // for kjp tracking
  async getKJPButton(projectId, proposalId, type = "KJP") {
    const url = `${this.endpoints.GET_BUTTON_DISABLE}?project_id=${projectId}&proposal_id=${proposalId}&type=${type}`;
    return this.get(url);
  }

  // for paymnet tracking
  async getPaymentButton(projectId, proposalId, type = "Payment") {
    const url = `${this.endpoints.GET_BUTTON_DISABLE}?project_id=${projectId}&proposal_id=${proposalId}&type=${type}`;
    return this.get(url);
  }

  async getOwnerCompensationSection23(projectId, proposalId) {
    try {
      if (!projectId || !proposalId) {
        throw new Error("Project ID and Proposal ID are required");
      }
      const params = {
        projectId,
        proposalId,
      };
      const response = await this.get("/getOwnerCompensation", params);

      return {
        status: 200,
        data: response,
      };
    } catch (error) {
      throw new Error("Failed to fetch owner compensation data");
    }
  }

  async postAddOwnerCompensation(compensationData) {
    try {
      const response = await this.api.post(
        this.endpoints.POST_ADD_OWNER_COMPENSATION,
        compensationData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      return response;
    } catch (error) {
      console.error("Error adding owner compensation record:", error);
      throw error;
    }
  }

  async patchUpdateOwnerCompensation(compId, compensationData) {
    try {
      if (!compId) {
        throw new Error("Compensation ID (compId) is required for update");
      }

      // Minimal payload with only essential compensation fields
      const payload = {
        // Land compensation
        land_amount_multiplied: parseFloat(
          compensationData.land_amount_multiplied ||
          compensationData.landMultiplied ||
          0,
        ),
        land_rate: parseFloat(
          compensationData.land_rate || compensationData.landRate || 0,
        ),
        land_amount: parseFloat(
          compensationData.land_amount ||
          compensationData.landRateFinalAmount ||
          0,
        ),
        govt_recovery:
          compensationData.govt_recovery ||
          compensationData.govt_recovery ||
          "",

        // Asset amounts (focusing on the main amount fields)
        structure_amount: parseFloat(
          compensationData.structure_amount ||
          compensationData.structureAmount ||
          0,
        ),
        tree_amount: parseFloat(
          compensationData.tree_amount || compensationData.treeAmount || 0,
        ),
        forest_tree_amount: parseFloat(
          compensationData.forest_tree_amount ||
          compensationData.forest_tree_amount ||
          0,
        ),
        crop_amount: parseFloat(
          compensationData.crop_amount || compensationData.cropAmount || 0,
        ),
        water_body_amount: parseFloat(
          compensationData.water_body_amount ||
          compensationData.waterBodyAmount ||
          0,
        ),
        borewell_amount: parseFloat(
          compensationData.borewell_amount ||
          compensationData.borewellAmount ||
          0,
        ),
        home_amount: parseFloat(
          compensationData.home_amount || compensationData.homeAmount || 0,
        ),
        pipeline_amount: parseFloat(
          compensationData.pipeline_amount ||
          compensationData.pipelineAmount ||
          0,
        ),
        wire_amount: parseFloat(
          compensationData.wire_amount || compensationData.wireAmount || 0,
        ),
        tinshed_amount: parseFloat(
          compensationData.tinshed_amount ||
          compensationData.tinshedAmount ||
          0,
        ),
        other_asset_amount: parseFloat(
          compensationData.other_asset_amount ||
          compensationData.otherAssetAmount ||
          0,
        ),

        // Rates (if they exist in DB)
        structure_rate: parseFloat(
          compensationData.structure_rate ||
          compensationData.structureRate ||
          0,
        ),
        tree_rate: parseFloat(
          compensationData.tree_rate || compensationData.treeRate || 0,
        ),
        crop_rate: parseFloat(
          compensationData.crop_rate || compensationData.cropRate || 0,
        ),
        water_body_rate: parseFloat(
          compensationData.water_body_rate ||
          compensationData.waterBodyRate ||
          0,
        ),
        borewell_rate: parseFloat(
          compensationData.borewell_rate || compensationData.borewellRate || 0,
        ),
        home_rate: parseFloat(
          compensationData.home_rate || compensationData.homeRate || 0,
        ),
        pipeline_rate: parseFloat(
          compensationData.pipeline_rate || compensationData.pipelineRate || 0,
        ),
        wire_rate: parseFloat(
          compensationData.wire_rate || compensationData.wireRate || 0,
        ),
        other_asset_rate: parseFloat(
          compensationData.other_asset_rate ||
          compensationData.otherAssetRate ||
          0,
        ),

        // Final compensation amounts
        solatium_compensation_amount: parseFloat(
          compensationData.solatium_compensation_amount ||
          compensationData.solatiumAmount ||
          0,
        ),
        interest_amount: parseFloat(
          compensationData.interest_amount ||
          compensationData.interestAmount ||
          0,
        ),
        additional_compensation: parseFloat(
          compensationData.additional_compensation ||
          compensationData.additionalCompensation ||
          0,
        ),
        total_compensation: parseFloat(
          compensationData.total_compensation ||
          compensationData.totalCompensation ||
          0,
        ),

        // Interest
        interest_rate: parseFloat(compensationData.interest_rate || 0),
        intrest_start_dt: compensationData.intrest_start_dt,
        intrest_end_dt: compensationData.intrest_end_dt,
        advance_payment_interest_amount: parseFloat(
          compensationData.advance_payment_interest_amount,
        ),

        COMPENSATION_STATUS: compensationData.COMPENSATION_STATUS,
        compensation_approval_date: compensationData.compensation_approval_date,
        compensation_approval_authority:
          compensationData.compensation_approval_authority,
        compensation_approval_reference:
          compensationData.compensation_approval_reference,
      };

      // Remove NaN and zero values to keep payload clean
      const cleanPayload = Object.fromEntries(
        Object.entries(payload).filter(([key, value]) => {
          return !Number.isNaN(value) && value !== null && value !== undefined;
        }),
      );

      const response = await this.api.patch(
        `${this.endpoints.PATCH_UPDATE_OWNER_COMPENSATION}?compId=${compId}`,
        cleanPayload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      return response;
    } catch (error) {
      console.error("Error updating compensation record:", error);
      console.error("Error details:", error.response?.data || error.message);

      // Enhance error message for better debugging
      const errorMessage =
        error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        "Failed to update compensation record";

      const enhancedError = new Error(errorMessage);
      enhancedError.status = error.response?.status;
      enhancedError.response = error.response;

      throw enhancedError;
    }
  }

  async patchUpdateOwnerCompensationNotice(compId, compensationData) {
    try {
      if (!compId) {
        throw new Error("Compensation ID (compId) is required for update");
      }
      // Minimal payload with only essential compensation fields
      const payload = {
        scheduled_date: compensationData.scheduled_date,
        scheduled_time: compensationData.scheduled_time,
      };

      // Remove NaN and zero values to keep payload clean
      const cleanPayload = Object.fromEntries(
        Object.entries(payload).filter(([key, value]) => {
          return !Number.isNaN(value) && value !== null && value !== undefined;
        }),
      );

      const response = await this.api.patch(
        `${this.endpoints.PATCH_UPDATE_OWNER_COMPENSATION}?compId=${compId}`,
        cleanPayload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      return response;
    } catch (error) {
      console.error("Error updating compensation record:", error);
      console.error("Error details:", error.response?.data || error.message);

      // Enhance error message for better debugging
      const errorMessage =
        error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        "Failed to update compensation record";

      const enhancedError = new Error(errorMessage);
      enhancedError.status = error.response?.status;
      enhancedError.response = error.response;

      throw enhancedError;
    }
  }

  //Agency
  async getAgencyCompensation(
    projectId,
    proposalId,
    distName = null,
    talukaName = null,
    villName = null,
  ) {
    try {
      if (!projectId || !proposalId) {
        throw new Error("Project ID and Proposal ID are required");
      }

      // Build parameters object
      const params = {
        projectId,
        proposalId,
      };

      // Add optional parameters only if they exist
      // if (distName) params.distName = distName;
      // if (talukaName) params.talukaName = talukaName;
      // if (villName) params.villName = villName;

      const response = await this.get("/getAgency", params);

      return {
        status: 200,
        data: response,
      };
    } catch (error) {
      console.error("Error fetching agency compensation:", error);
      console.error("Error details:", error.response?.data || error.message);
      throw new Error("Failed to fetch agency compensation data");
    }
  }

  //Payment
  async getPaymentCompensation(params) {
    try {
      if (!params.projectId || !params.proposalId) {
        throw new Error("Project ID and Proposal ID are required");
      }

      const response = await this.get("/getPaymentCompensation", params);

      return {
        status: 200,
        data: response,
      };
    } catch (error) {
      console.error("Error fetching owner compensation:", error);
      throw new Error("Failed to fetch owner compensation data");
    }
  }

  async getPaymentCompensationById(pmtId) {
    try {
      if (!pmtId) {
        throw new Error("Project ID and Proposal ID are required");
      }

      const response = await this.get("/getPayment", { comId: pmtId });

      return response;
    } catch (error) {
      console.error("Error fetching owner compensation:", error);
      throw new Error("Failed to fetch owner compensation data");
    }
  }

  async postAddPayment(compensationData) {
    return this.post(this.endpoints.POST_ADD_PAYMENT, compensationData);
  }

  //Private Objection
  async postAddPrivateObjection(formDataOrDataObject, fileParam = null) {
    try {
      let finalFormData;

      // Check if the input is already a FormData object (new approach)
      // or a plain object (old approach)
      if (formDataOrDataObject instanceof FormData) {
        // New approach: FormData is already prepared by the calling function
        finalFormData = formDataOrDataObject;
      } else {
        // Old approach: Build FormData from data object and separate file
        const data = formDataOrDataObject;
        const file = fileParam;

        finalFormData = new FormData();

        // Map the data fields correctly
        finalFormData.append("project_id", data.projectId || data.project_id);
        finalFormData.append(
          "objection_date",
          data.objectionDate || data.objection_date,
        );
        // finalFormData.append('objection_no', data.objectionNo || data.objection_no || 'OBJ-2024-001');
        finalFormData.append("owner_name", data.owner_name || data.owner_name);
        finalFormData.append(
          "owner_contact",
          data.owner_contact || data.owner_contact,
        );
        finalFormData.append(
          "owner_email",
          data.owner_email || data.owner_email,
        );
        finalFormData.append(
          "owner_address",
          data.owner_address || data.owner_address,
        );
        // finalFormData.append('objector_type', data.objectorType || data.objector_type || 'Individual');

        finalFormData.append(
          "representative_name",
          data.representative_name || data.representative_name,
        );
        finalFormData.append(
          "relationship_with_owner",
          data.relationship_with_owner || data.relationship_with_owner,
        );

        // Identity proof fields
        finalFormData.append(
          "identity_proof_type",
          data.identity_proof_type || data.identity_proof_type || "",
        );
        finalFormData.append(
          "identity_proof_no",
          data.identity_proof_no || data.identity_proof_no || "",
        );

        // Location fields
        finalFormData.append("survey_no", data.survey_no || data.survey_no);
        finalFormData.append(
          "village_name",
          data.village_name || data.village_name,
        );
        finalFormData.append(
          "taluka_name",
          data.taluka_name || data.taluka_name,
        );
        finalFormData.append("district_name", data.dist_name || data.dist_name);

        // Objection details
        finalFormData.append(
          "objection_summary",
          data.objection_summary || data.objection_summary,
        );
        // finalFormData.append('objection_summary', data.objectionSummary || data.objection_summary);
        finalFormData.append(
          "objection_details",
          data.objectionDetails || data.objection_details,
        );
        finalFormData.append(
          "objection_other",
          data.objectionOther || data.objection_other || "",
        );

        // Measurement details
        if (data.recordedArea || data.recorded_area) {
          finalFormData.append(
            "recorded_area",
            data.recordedArea || data.recorded_area,
          );
        }
        if (data.claimedArea || data.claimed_area) {
          finalFormData.append(
            "claimed_area",
            data.claimedArea || data.claimed_area,
          );
        }
        finalFormData.append(
          "area_unit",
          data.areaUnit || data.area_unit || "sqm",
        );

        // Compensation details
        if (data.recordedCompensation || data.recorded_compensation) {
          finalFormData.append(
            "recorded_compensation",
            data.recordedCompensation || data.recorded_compensation,
          );
        }
        if (data.expectedCompensation || data.expected_compensation) {
          finalFormData.append(
            "expected_compensation",
            data.expectedCompensation || data.expected_compensation,
          );
        }

        // Tree details
        if (data.numTreesRecorded || data.num_trees_recorded) {
          finalFormData.append(
            "num_trees_recorded",
            data.numTreesRecorded || data.num_trees_recorded,
          );
        }
        if (data.numTreesClaimed || data.num_trees_claimed) {
          finalFormData.append(
            "num_trees_claimed",
            data.numTreesClaimed || data.num_trees_claimed,
          );
        }
        if (data.treeDetails || data.tree_details) {
          finalFormData.append(
            "tree_details",
            data.treeDetails || data.tree_details,
          );
        }

        // System fields
        finalFormData.append(
          "supporting_documents",
          (
            data.supportingDocuments ||
            data.supporting_documents ||
            true
          ).toString(),
        );
        finalFormData.append(
          "document_references",
          data.documentReferences || data.document_references || "",
        );
        finalFormData.append(
          "OBJECTION_STATUS",
          data.objectionStatus || data.objection_status || "Pending",
        );
        finalFormData.append(
          "hearing_required",
          (data.hearingRequired || data.hearing_required || true).toString(),
        );
        // finalFormData.append('submission_timestamp', data.submissionTimestamp || data.submission_timestamp || new Date().toISOString());

        // Default hearing details (can be updated later)
        finalFormData.append(
          "hearing_date",
          data.hearingDate || data.hearing_date || "2024-12-10T11:00:00",
        );
        finalFormData.append(
          "hearing_venue",
          data.hearingVenue || data.hearing_venue || "Tehsildar Office, Haveli",
        );
        finalFormData.append(
          "hearing_officer",
          data.hearingOfficer || data.hearing_officer || "Mr. Suresh Kadam",
        );

        // Handle file attachment (support both parameter approaches)
        if (file) {
          finalFormData.append("identityProof", file);
        }
      }

      // If FormData was pre-built, check if it needs the file field name adjustment
      if (formDataOrDataObject instanceof FormData) {
        // Check if identity_proof_file exists and rename it to identityProof for backend compatibility
        let identityFile = null;
        let hasIdentityProofFile = false;

        // Check what file fields exist in the FormData
        for (let pair of finalFormData.entries()) {
          if (pair[0] === "identity_proof_file" && pair[1] instanceof File) {
            identityFile = pair[1];
            hasIdentityProofFile = true;
            break;
          }
        }

        // If identity_proof_file exists, remove it and add as identityProof
        if (hasIdentityProofFile && identityFile) {
          // Create a new FormData to rebuild with correct field name
          const newFormData = new FormData();

          // Copy all fields except identity_proof_file
          for (let pair of finalFormData.entries()) {
            if (pair[0] !== "identity_proof_file") {
              newFormData.append(pair[0], pair[1]);
            }
          }

          // Add the file with correct field name
          newFormData.append("identityProof", identityFile);
          finalFormData = newFormData;
        }
      }

      // Log the final FormData entries for debugging
      for (let pair of finalFormData.entries()) {
        const value =
          pair[1] instanceof File
            ? `[File: ${pair[1].name}, Size: ${pair[1].size}]`
            : pair[1];
        console.log("value", value);
      }

      const response = await this.api.post(
        this.endpoints.POST_ADD_PRIVATE_OBJECTION,
        finalFormData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          // Add timeout and other configurations
          timeout: 30000, // 30 seconds timeout
          maxContentLength: Infinity,
          maxBodyLength: Infinity,
        },
      );

      return response.data;
    } catch (error) {
      console.error("🌐 API Service: Upload process failed", error);

      // Enhanced error logging
      if (error.response) {
        console.error(
          "🌐 API Service: Response Error Status:",
          error.response.status,
        );
        console.error(
          "🌐 API Service: Response Error Data:",
          error.response.data,
        );
        console.error(
          "🌐 API Service: Response Error Headers:",
          error.response.headers,
        );
      } else if (error.request) {
        console.error("🌐 API Service: Request Error:", error.request);
        console.error("🌐 API Service: No response received from server");
      } else {
        console.error("🌐 API Service: General Error:", error.message);
      }

      // Throw a more descriptive error
      const errorMessage =
        error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        "Upload process failed";
      const enhancedError = new Error(errorMessage);
      enhancedError.status = error.response?.status;
      enhancedError.response = error.response;

      throw enhancedError;
    }
  }

  async getPrivateObjectionById(objId) {
    try {
      const response = await this.api.get(
        `${this.endpoints.GET_PRIVATE_OBJECTIONS}?objId=${objId}`,
      );
      return response.data;
    } catch (error) {
      console.error("API Error in getPrivateObjectionById:", error);
      throw error;
    }
  }

  async getVerifyOwnerSurveyNo(surveyNo, projectId, proposalId) {
    try {
      const response = await this.api.get(
        `/getVerifyOwnerSurveyNo?surveyNo=${encodeURIComponent(surveyNo)}&projectId=${encodeURIComponent(projectId)}&proposalId=${encodeURIComponent(proposalId)}`,
      );
      return response;
    } catch (error) {
      console.error("API Error in getVerifyOwnerSurveyNo:", error);
      throw error;
    }
  }

  // Final Award Methods
  async getFinalAward(projectId, proposalId) {
    try {
      if (!projectId || !proposalId) {
        throw new Error("Project ID and Proposal id are required");
      }
      return (
        await this.api.get(this.endpoints.GET_FINAL_AWARD, {
          params: { projectId, proposalId },
        })
      ).data;
    } catch (error) {
      console.error("Error fetching final award:", error);
      throw error;
    }
  }

  //Send to LAO
  async postTracking(data, type = "LAO") {
    const url = `${this.endpoints.POST_TRACKING}?type=${type}`;
    return this.post(url, data);
  }

  async postSendToNext(data, type = "LAO") {
    const url = `${this.endpoints.SEND_TO_NEXT}?type=${type}`;
    return this.post(url, data);
  }

  // -------------------------
  // ASSIGN ALL USER API CALL
  // ----------------------------

  //Send to LAO(fetch assign lao)
  async getAllAssignUserRoleLAO(role, projectId, proposalId) {
    if (!projectId || !proposalId) {
      console.warn("Missing projectId / proposalId");
      return Promise.resolve({ data: [] });
    }

    return this.get(this.endpoints.GET_ALL_USER, {
      role: 3,
      projectId,
      proposalId,
    });
  }

  //Send to Samanvay
  async getAllUserRoleSamanvay(role = 6) {
    return this.get(this.endpoints.GET_ALL_USER, { role });
  }

  //Send to Samanvay(fetch assign Samanvay)
  async getAllAssignUserRoleSamanvay(role, projectId, proposalId) {
    if (!projectId || !proposalId) {
      console.warn("Missing projectId / proposalId");
      return Promise.resolve({ data: [] });
    }

    return this.get(this.endpoints.GET_ALL_USER, {
      role,
      projectId,
      proposalId,
    });
  }

  //Send to collctor
  async getAllUserCollector(role = 1) {
    return this.get(this.endpoints.GET_ALL_USER, { role });
  }

  //Send to collctor(fetch assign collector)
  async getAllAssignUserCollector(role, projectId, proposalId) {
    if (!projectId || !proposalId) {
      console.warn("Missing projectId / proposalId");
      return Promise.resolve({ data: [] });
    }
    return this.get(this.endpoints.GET_ALL_USER, {
      role: 1,
      projectId,
      proposalId,
    });
  }

  // Send to DRO(fetch assign DRO)
  async getAllUserRoleDRO(role, projectId, proposalId) {
    if (!projectId || !proposalId) {
      console.warn("Missing projectId / proposalId");
      return Promise.resolve({ data: [] });
    }
    return this.get(this.endpoints.GET_ALL_USER, {
      role: 22,
      projectId,
      proposalId,
    });
  }

  //Send to Tehsilar(fetch assign Tehsildar)
  async getAllUserTehsildar(role, projectId, proposalId) {
    if (!projectId || !proposalId) {
      console.warn("Missing projectId / proposalId");
      return Promise.resolve({ data: [] });
    }
    return this.get(this.endpoints.GET_ALL_USER, {
      role: 5,
      projectId,
      proposalId,
    });
  }

  //Send to DSLR(fetch assign DSLR)
  async getAllUserRoleDSLR(role, projectId, proposalId) {
    if (!projectId || !proposalId) {
      console.warn("Missing projectId / proposalId");
      return Promise.resolve({ data: [] });
    }

    return this.get(this.endpoints.GET_ALL_USER, {
      role: 15,
      projectId,
      proposalId,
    });
  }

  async getAllUserRoleSLR(role = 15) {
    return this.get(this.endpoints.GET_ALL_USER, { role });
  }

  //Send to ProjectIncharge(fetch assign ProjectIncharge)
  async getAllUserRoleProjectIncharge(role, projectId, proposalId) {
    if (!projectId || !proposalId) {
      console.warn("Missing projectId / proposalId");
      return Promise.resolve({ data: [] });
    }

    return this.get(this.endpoints.GET_ALL_USER, {
      role: 18,
      projectId,
      proposalId,
    });
  }

  async getAllUserRoleSurveyor(role, projectId, proposalId) {
    if (!projectId || !proposalId) {
      console.warn("Missing projectId / proposalId");
      return Promise.resolve({ data: [] });
    }

    return this.get(this.endpoints.GET_ALL_USER, {
      role: 7,
      projectId,
      proposalId,
    });
  }

  async getAllAssignAgricultureAgency(role, projectId, proposalId) {
    if (!projectId || !proposalId) {
      console.warn("Missing projectId / proposalId");
      return Promise.resolve({ data: [] });
    }

    return this.get(this.endpoints.GET_ALL_USER, {
      role: 21,
      projectId,
      proposalId,
    });
  }

  async getAllAssignTPAgency(role, projectId, proposalId) {
    if (!projectId || !proposalId) {
      console.warn("Missing projectId / proposalId");
      return Promise.resolve({ data: [] });
    }

    return this.get(this.endpoints.GET_ALL_USER, {
      role: 23,
      projectId,
      proposalId,
    });
  }

  async getAllAssignForestAgency(role, projectId, proposalId) {
    if (!projectId || !proposalId) {
      console.warn("Missing projectId / proposalId");
      return Promise.resolve({ data: [] });
    }

    return this.get(this.endpoints.GET_ALL_USER, {
      role: 24,
      projectId,
      proposalId,
    });
  }

  //Send to LAO
  async getAllUserRoleLAO(role = 3) {
    return this.get(this.endpoints.GET_ALL_USER, { role });
  }

  async getAssignUserRoleProjectIncharge(role = 18, projectId, proposalId) {
    return this.get(this.endpoints.GET_ALL_USER, {
      role,
      projectId,
      proposalId,
    });
  }

  async postTrackingLAO(data, type = "LAO") {
    const url = `${this.endpoints.POST_TRACKING}?type=${type}`;
    return this.post(url, data);
  }

  async getAssignLAO(role = 3, projectId, proposalId) {
    return this.get(this.endpoints.GET_ALL_USER, {
      role,
      projectId,
      proposalId,
    });
  }

  // ----------------------------------------



  //Send To ProjectInchage11
  async postTrackingFundSection11(data, type = "ProjectInchargeFundSection11") {
    const url = `${this.endpoints.POST_TRACKING}?type=${type}`;
    return this.post(url, data);
  }

  //Send To ProjectInchage19
  async postTrackingFundSection19(data, type = "ProjectInchargeFundSection19") {
    const url = `${this.endpoints.POST_TRACKING}?type=${type}`;
    return this.post(url, data);
  }

  //Send To LAOFundSection11
  async postTrackingFundSendToLAOSection11(data, type = "LAOFundSection11") {
    const url = `${this.endpoints.POST_TRACKING}?type=${type}`;
    return this.post(url, data);
  }

  //Send To LAOFundSection19
  async postTrackingFundSendToLAOSection19(data, type = "LAOFundSection19") {
    const url = `${this.endpoints.POST_TRACKING}?type=${type}`;
    return this.post(url, data);
  }

  async postTrackingTehsildar(data, type = "TehsildarReport") {
    const url = `${this.endpoints.POST_TRACKING}?type=${type}`;
    return this.post(url, data);
  }

  async getTehsildarButton(projectId, proposalId, type = "TehsildarReport") {
    const url = `${this.endpoints.GET_BUTTON_DISABLE}?project_id=${projectId}&proposal_id=${proposalId}&type=${type}`;
    return this.get(url);
  }

  async postTrackingCollector(data, type = "Collector") {
    const url = `${this.endpoints.POST_TRACKING}?type=${type}`;
    return this.post(url, data);
  }

  async getCollectorButton(projectId, proposalId, type = "Collector") {
    const url = `${this.endpoints.GET_BUTTON_DISABLE}?project_id=${projectId}&proposal_id=${proposalId}&type=${type}`;
    return this.get(url);
  }
  async getSamanvayFinalButton(projectId, proposalId, type = "SamanvayFinal") {
    const url = `${this.endpoints.GET_BUTTON_DISABLE}?project_id=${projectId}&proposal_id=${proposalId}&type=${type}`;
    return this.get(url);
  }
  async getLAOassignButton(projectId, proposalId, type = "LAO") {
    const url = `${this.endpoints.GET_BUTTON_DISABLE}?project_id=${projectId}&proposal_id=${proposalId}&type=${type}`;
    return this.get(url);
  }

  //Send to Samanvay section-11
  async postTrackingSamanvaySection11(data, type = "SamanvaySection11") {
    const url = `${this.endpoints.POST_TRACKING}?type=${type}`;
    return this.post(url, data);
  }
  async postTrackingSamanvayFinalSection11(data, type = "SamanvayFinalSection11") {
    const url = `${this.endpoints.POST_TRACKING}?type=${type}`;
    return this.post(url, data);
  }

  async getfetchSamanvayButtonSection11(
    projectId,
    proposalId,
    type = "SamanvaySection11",
  ) {
    if (!projectId || !proposalId) {
      throw new Error("Missing projectId or proposalId");
    }
    const url = `${this.endpoints.GET_BUTTON_DISABLE}?project_id=${projectId}&proposal_id=${proposalId}&type=${type}`;
    return this.get(url);
  }

  //Send to Collector section-11
  async postTrackingCollectorSection11(data, type = "CollectorSection11") {
    const url = `${this.endpoints.POST_TRACKING}?type=${type}`;
    return this.post(url, data);
  }

  async getfetchCollectorButtonSection11(
    projectId,
    proposalId,
    type = "CollectorSection11",
  ) {
    if (!projectId || !proposalId) {
      throw new Error("Missing projectId or proposalId");
    }
    const url = `${this.endpoints.GET_BUTTON_DISABLE}?project_id=${projectId}&proposal_id=${proposalId}&type=${type}`;
    return this.get(url);
  }

  //Send to LAO Section-11
  async postTrackingLAOPublish(data, type = "LAOPublish") {
    const url = `${this.endpoints.POST_TRACKING}?type=${type}`;
    return this.post(url, data);
  }

  async getfetchLAOPublishButton(projectId, proposalId, type = "LAOPublish") {
    if (!projectId || !proposalId) {
      throw new Error("Missing projectId or proposalId");
    }
    const url = `${this.endpoints.GET_BUTTON_DISABLE}?project_id=${projectId}&proposal_id=${proposalId}&type=${type}`;
    return this.get(url);
  }

  // Extended date
  async postTrackingSamanvayExtentedDate(data, type = "SamanvayExtendDate") {
    const url = `${this.endpoints.POST_TRACKING}?type=${type}`;
    return this.post(url, data);
  }
 async postTrackingSamanvayExtentedDate19(data, type = "ExtendDateSamanvaySection19") {
    const url = `${this.endpoints.POST_TRACKING}?type=${type}`;
    return this.post(url, data);
  }
  async postTrackingSamanvayFinalExtentedDate19(data, type = "ExtendDateSamanvayFinalSection19") {
    const url = `${this.endpoints.POST_TRACKING}?type=${type}`;
    return this.post(url, data);
  }
  async getSamanvayExtentedDateButton(
    projectId,
    proposalId,
    type = "SamanvayExtendDate",
  ) {
    const url = `${this.endpoints.GET_BUTTON_DISABLE}?project_id=${projectId}&proposal_id=${proposalId}&type=${type}`;
    return this.get(url);
  }

  async postTrackingCollectorExtentedDate(data, type = "CollectorExtendDate") {
    const url = `${this.endpoints.POST_TRACKING}?type=${type}`;
    return this.post(url, data);
  }
   async postTrackingCollectorExtentedDate19(data, type = "ExtendDateCollectorSection19") {
    const url = `${this.endpoints.POST_TRACKING}?type=${type}`;
    return this.post(url, data);
  }

  async getCollectorExtentedDateButton(
    projectId,
    proposalId,
    type = "CollectorExtendDate",
  ) {
    const url = `${this.endpoints.GET_BUTTON_DISABLE}?project_id=${projectId}&proposal_id=${proposalId}&type=${type}`;
    return this.get(url);
  }

  async postTrackingbackToLaoExtentedDate(data, type = "SamanvayFinalExtendDate") {
    const url = `${this.endpoints.POST_TRACKING}?type=${type}`;
    return this.post(url, data);
  }
   async postTrackingbackToLaoExtentedDate19(data, type = "ExtendDateLAOSection19") {
    const url = `${this.endpoints.POST_TRACKING}?type=${type}`;
    return this.post(url, data);
  }


  async getLaoExtentedDateButton(
    projectId,
    proposalId,
    type = "LAOExtendDate",
  ) {
    const url = `${this.endpoints.GET_BUTTON_DISABLE}?project_id=${projectId}&proposal_id=${proposalId}&type=${type}`;
    return this.get(url);
  }

  //Send to SLR

  async postTrackingSLR(data, type = "SLR") {
    const url = `${this.endpoints.POST_TRACKING}?type=${type}`;
    return this.post(url, data);
  }

  async getDSLRButton(projectId, proposalId, type = "SLR") {
    if (!projectId || !proposalId) {
      throw new Error("Missing projectId or proposalId");
    }
    const url = `${this.endpoints.GET_BUTTON_DISABLE}?project_id=${projectId}&proposal_id=${proposalId}&type=${type}`;
    return this.get(url);
  }

  //Send to Surveyor
  async postTrackingSurveyor(data, type = "Surveyor") {
    const url = `${this.endpoints.POST_TRACKING}?type=${type}`;
    return this.post(url, data);
  }

  async postTrackingSamanvay(data, type = "Samanvay") {
    const url = `${this.endpoints.POST_TRACKING}?type=${type}`;
    return this.post(url, data);
  }
  async postTrackingSamanvayFinal(data, type = "SamanvayFinal") {
    const url = `${this.endpoints.POST_TRACKING}?type=${type}`;
    return this.post(url, data);
  }
   async getTrackingwiseButton(projectId, proposalId, page) {
    if (!projectId || !proposalId) {
      throw new Error("Missing projectId or proposalId");
    }
    const url = `${this.endpoints.GET_BUTTON}?projectId=${projectId}&proposalId=${proposalId}&page=${page}`;
    return this.get(url);
  }
  async getTrackingPermission(projectId, proposalId,role) {
  if (!projectId || !proposalId) {
    throw new Error("Missing projectId or proposalId");
  }

  const url = `${this.endpoints.GET_TRACKING_PERMISSION}?projectId=${projectId}&proposalId=${proposalId}&type=${role}`;
  return this.get(url);
}

async patchUpdateTrackingPermission(id, payload = {}) {
  if (!id) {
    throw new Error("Missing tracking permission id");
  }
  const url = `${this.endpoints.PATCH_TRACKING_PERMISSION}?id=${id}`;
  return this.patch(url, payload);
}

async getTrackingwiseSEC11Button(projectId, proposalId, page = "section11") {
    if (!projectId || !proposalId) {
      throw new Error("Missing projectId or proposalId");
    }
    const url = `${this.endpoints.GET_BUTTON}?projectId=${projectId}&proposalId=${proposalId}&page=${page}`;
    return this.get(url);
  }
  async getTrackingwiseSEC15Button(projectId, proposalId, page = "section15") {
    if (!projectId || !proposalId) {
      throw new Error("Missing projectId or proposalId");
    }
    const url = `${this.endpoints.GET_BUTTON}?projectId=${projectId}&proposalId=${proposalId}&page=${page}`;
    return this.get(url);
  }
  
  async getSamanvayButton(projectId, proposalId, type = "Samanvay") {
    if (!projectId || !proposalId) {
      throw new Error("Missing projectId or proposalId");
    }
    const url = `${this.endpoints.GET_BUTTON_DISABLE}?project_id=${projectId}&proposal_id=${proposalId}&type=${type}`;
    return this.get(url);
  }
  async getSamanvayBackButton(projectId, proposalId, type = "Back_Samanvay") {
    if (!projectId || !proposalId) {
      throw new Error("Missing projectId or proposalId");
    }
    const url = `${this.endpoints.GET_BUTTON_DISABLE}?project_id=${projectId}&proposal_id=${proposalId}&type=${type}`;
    return this.get(url);
  }


  //Send back to LAO
  async postTrackingbacktoLao(data, type = "LAOV") {
    const url = `${this.endpoints.POST_TRACKING}?type=${type}`;
    return this.post(url, data);
  }

  //Send back to SLR
  async postTrackingbacktoSlr(data, type = "SLRV") {
    const url = `${this.endpoints.POST_TRACKING}?type=${type}`;
    return this.post(url, data);
  }

  //Send to Samanvay section-19
  async postTrackingSamanvaySection19(data, type = "SamanvaySection19") {
    const url = `${this.endpoints.POST_TRACKING}?type=${type}`;
    return this.post(url, data);
  }
  async postTrackingSamanvaySection19Final(data, type = "SamanvayFinalSection19") {
    const url = `${this.endpoints.POST_TRACKING}?type=${type}`;
    return this.post(url, data);
  }

  async getfetchSamanvayButtonSection19(
    projectId,
    proposalId,
    type = "SamanvaySection19",
  ) {
    if (!projectId || !proposalId) {
      throw new Error("Missing projectId or proposalId");
    }
    const url = `${this.endpoints.GET_BUTTON_DISABLE}?project_id=${projectId}&proposal_id=${proposalId}&type=${type}`;
    return this.get(url);
  }

  //Send to Collector section-19
  async postTrackingCollectorSection19(data, type = "CollectorSection19") {
    const url = `${this.endpoints.POST_TRACKING}?type=${type}`;
    return this.post(url, data);
  }

  async getfetchCollectorButtonSection19(
    projectId,
    proposalId,
    type = "CollectorSection19",
  ) {
    if (!projectId || !proposalId) {
      throw new Error("Missing projectId or proposalId");
    }
    const url = `${this.endpoints.GET_BUTTON_DISABLE}?project_id=${projectId}&proposal_id=${proposalId}&type=${type}`;
    return this.get(url);
  }

  //Send to LAO Section-19
  async postTrackingLAOPublishSection19(data, type = "LAOPublishSection19") {
    const url = `${this.endpoints.POST_TRACKING}?type=${type}`;
    return this.post(url, data);
  }

  async getfetchLAOPublishSection19Button(
    projectId,
    proposalId,
    type = "LAOPublishSection19",
  ) {
    if (!projectId || !proposalId) {
      throw new Error("Missing projectId or proposalId");
    }
    const url = `${this.endpoints.GET_BUTTON_DISABLE}?project_id=${projectId}&proposal_id=${proposalId}&type=${type}`;
    return this.get(url);
  }

  //JMR Send to next agency
  async postTrackingAgency(data, type) {
    const url = `${this.endpoints.POST_TRACKING}?type=${type}`;
    return this.post(url, data);
  }

  //Agency to Compansation
  async postTrackingCompensation(data, type = "Compensation") {
    const url = `${this.endpoints.POST_TRACKING}?type=${type}`;
    return this.post(url, data);
  }

  // section 23 - Samanvay
  async postTrackingSection23Samanvay(data, type = "SamanvaySection23") {
    const url = `${this.endpoints.POST_TRACKING}?type=${type}`;
    return this.post(url, data);
  }
  async postTrackingSection23SamanvayFinal(data, type = "SamanvayFinalSection23") {
    const url = `${this.endpoints.POST_TRACKING}?type=${type}`;
    return this.post(url, data);
  }

  async getSection23SamanvayLAOButton(
    projectId,
    proposalId,
    type = "SamanvaySection23",
  ) {
    const url = `${this.endpoints.GET_BUTTON_DISABLE}?project_id=${projectId}&proposal_id=${proposalId}&type=${type}`;
    return this.get(url);
  }

  // section 23 - Collector
  async postTrackingSection23Collector(data, type = "CollectorSection23") {
    const url = `${this.endpoints.POST_TRACKING}?type=${type}`;
    return this.post(url, data);
  }

  async getSection23CollectorButton(
    projectId,
    proposalId,
    type = "CollectorSection23",
  ) {
    const url = `${this.endpoints.GET_BUTTON_DISABLE}?project_id=${projectId}&proposal_id=${proposalId}&type=${type}`;
    return this.get(url);
  }

  // section 23 - LAO
  async postTrackingSection23LAO(data, type = "LAOSection23") {
    const url = `${this.endpoints.POST_TRACKING}?type=${type}`;
    return this.post(url, data);
  }

  async getSection23LAOButton(projectId, proposalId, type = "LAOSection23") {
    const url = `${this.endpoints.GET_BUTTON_DISABLE}?project_id=${projectId}&proposal_id=${proposalId}&type=${type}`;
    return this.get(url);
  }

  // KJP
  async postTrackingDslrKjp(data, type = "DSLRKJP") {
    const url = `${this.endpoints.POST_TRACKING}?type=${type}`;
    return this.post(url, data);
  }

  async getDslrKjpButton(projectId, proposalId, type = "DSLRKJP") {
    const url = `${this.endpoints.GET_BUTTON_DISABLE}?project_id=${projectId}&proposal_id=${proposalId}&type=${type}`;
    return this.get(url);
  }

  async postTrackingTehsildarKjp(data, type = "TehsildarKJP") {
    const url = `${this.endpoints.POST_TRACKING}?type=${type}`;
    return this.post(url, data);
  }
  async getDslrKjpimage(data, type = "TehsildarKJP") {
    const url = `${this.endpoints.POST_TRACKING}?type=${type}`;
    return this.get(url, data);
  }

  async getTehsildarKJPButton(projectId, proposalId, type = "TehsildarKJP") {
    const url = `${this.endpoints.GET_BUTTON_DISABLE}?project_id=${projectId}&proposal_id=${proposalId}&type=${type}`;
    return this.get(url);
  }

  async postTrackingLAOKjp(data, type = "LAOKJP") {
    const url = `${this.endpoints.POST_TRACKING}?type=${type}`;
    return this.post(url, data);
  }

  async getLAOKjpButton(projectId, proposalId, type = "LAOKJP") {
    const url = `${this.endpoints.GET_BUTTON_DISABLE}?project_id=${projectId}&proposal_id=${proposalId}&type=${type}`;
    return this.get(url);
  }

  async getDROButton(projectId, proposalId, type = "DRO") {
    const url = `${this.endpoints.GET_BUTTON_DISABLE}?project_id=${projectId}&proposal_id=${proposalId}&type=${type}`;
    return this.get(url);
  }

  //FinalAward to KJP
  async postTrackingKJP(data, type = "KJP") {
    const url = `${this.endpoints.POST_TRACKING}?type=${type}`;
    return this.post(url, data);
  }

  //KJP to payment
  async postTrackingPayment(data, type = "Payment") {
    const url = `${this.endpoints.POST_TRACKING}?type=${type}`;
    return this.post(url, data);
  }
  //Agency to compasation
  async postTrackingfinalAward(data, type = "finalAward") {
    const url = `${this.endpoints.POST_TRACKING}?type=${type}`;
    return this.post(url, data);
  }
  //Agency selection
  async getAllUserRoleAgency(role = 21) {
    return this.get(this.endpoints.GET_ALL_USER, { role });
  }

  //Send to DRO
  async postTrackingDRO(data, type = "LandDRO") {
    const url = `${this.endpoints.POST_TRACKING}?type=${type}`;
    return this.post(url, data);
  }

  // ---------------------------------------------------
  //Send Back To...
  // -----------------------------------------------------
  async postTrackingbacktoProjectIncharge(data, type = "LAOV") {
    const url = `${this.endpoints.POST_TRACKING}?type=${type}`;
    return this.post(url, data);
  }

  // ------------------------------------------------------
  // // GET Namuna K
  // async getNamuna(projectId, proposalId) {
  //   const url = '${ this.endpoints.GET_NAMUNA_K }?projectId = ${ projectId }& proposalId=${ proposalId }';
  //   return this.get(url);
  // }

  // // POST/EDIT Namuna K
  // async postAddUpdateNamunaK(formData) {
  //   const url = this.endpoints.POST_ADD_UPDATE_NAMUNA_K;
  //   return this.post(url, formData);
  // }

  //KJP
  async getKJP(params) {
    try {
      if (!params.projectId || !params.proposalId) {
        throw new Error("Project ID and Proposal ID are required");
      }

      const response = await this.get(this.endpoints.GET_KJP, params);

      return {
        status: 200,
        data: response,
      };
    } catch (error) {
      console.error("Error fetching KJP data:", error);
      throw new Error("Failed to fetch KJP data");
    }
  }

  async updateKJP(measureId, kjpData) {
    try {
      if (!measureId) {
        throw new Error("Measure ID is required for KJP update");
      }

      const formData = new FormData();

      // Add KJP fields to FormData
      if (kjpData.kjp_date) {
        formData.append("kjp_date", kjpData.kjp_date);
      }
      if (kjpData.kjp_no) {
        formData.append("kjp_no", kjpData.kjp_no);
      }
      if (kjpData.kjp_remarks) {
        formData.append("kjp_remarks", kjpData.kjp_remarks);
      }

      // Handle KJP document/image
      if (kjpData.kjp_file && kjpData.kjp_file instanceof File) {
        formData.append("kjp_file", kjpData.kjp_file);
      }

      // Log FormData contents for debugging
      for (let pair of formData.entries()) {
        const value =
          pair[1] instanceof File ? `[File: ${pair[1].name}]` : pair[1];
        console.log(`${pair[0]}: ${value}`);
      }

      const response = await this.api.patch(
        `${this.endpoints.PATCH_UPDATE_KJP}?measureId=${measureId}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      return {
        status: response.status,
        data: response.data,
      };
    } catch (error) {
      console.error("Error updating KJP:", error);
      console.error("Error details:", error.response?.data || error.message);
      throw new Error("Failed to update KJP record");
    }
  }

  //For search
  async getSearch(paramsObj) {
    const params = new URLSearchParams();

    Object.entries(paramsObj).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        params.append(key, value);
      }
    });

    // Fixed: Remove spaces around the ? and use proper URL construction
    return this.get(`${this.endpoints.GET_SEARCH}?${params.toString()}`);
  }

  // async getAllDocuments(projectId, proposalId) {
  //   if (projectId == null || proposalId == null) {
  //     return {
  //       status: 0,
  //       data: [],
  //       message: "Missing projectId or proposalId",
  //     };
  //   }

  //   const url =
  //     `${this.endpoints.GET_ALL_DOCUMENTS}` +
  //     `?projectId=${projectId}&proposalId=${proposalId}`;

  //   const response = await this.get(url);

  //   // ✅ FIX: Return the full response, not just response.data
  //   return response;  // Changed from: return response.data;
  // }

  // getAllDocumentsZip(projectId, proposalId) {
  //   return this.api.get("/getAllDocuments", {
  //     params: {
  //       projectId,
  //       proposalId,
  //       download: "1"
  //     },
  //     responseType: "blob"
  //   });
  // }
  async getAllDocuments(projectId, proposalId) {
    if (projectId == null || proposalId == null) {
      return {
        status: 0,
        data: [],
        message: "Missing projectId or proposalId",
      };
    }

    const url =
      `${this.endpoints.GET_ALL_DOCUMENTS}` +
      `?projectId=${projectId}&proposalId=${proposalId}`;

    const response = await this.get(url);

    // ✅ FIX: Return the full response, not just response.data
    return response;  // Changed from: return response.data;
  }

  getAllDocumentsZip(projectId, proposalId) {
    return this.api.get("/getAllDocuments", {
      params: {
        projectId,
        proposalId,
        download: "1",
      },
      responseType: "arraybuffer",
      timeout: 60000,
    });
  }


  async updateProposalPublish(proposalId, data) {
    try {
      // Validate landId before making the API call
      if (
        !proposalId ||
        proposalId === "undefined" ||
        proposalId === undefined
      ) {
        throw new Error("Invalid landId provided for update operation");
      }

      const response = await this.patch(
        `${this.endpoints.UPDATE_PROPOSAL_PUBLISH}?proposalId=${proposalId}`,
        data,
      );

      // Check if response is ok
      if (response.status !== 200 && response.status !== 204) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
      const result = response.data;

      return {
        ok: true,
        data: result,
        status: response.status,
      };
    } catch (error) {
      console.error("Error updating land holding:", error);
      console.error("LanProposal IddId:", proposalId);
      console.error("Data:", data);

      // Re-throw with more descriptive error
      throw new Error(`Failed to update landholding: ${error.message}`);
    }
  }

  async getProposalPublish(projectId, proposalId) {
    try {
      const response = await this.api.get(
        `${this.endpoints.GET_PROPOSAL_PUBLISH}?projectId=${projectId}&proposalId=${proposalId}`,
      );
      return response; // instead of response.data
    } catch (error) {
      console.error("API Error in getGeneralObjectionById:", error);
      throw error;
    }
  }

  //getproposal with Namuna K
  async getProposal(projectId) {
    return this.get(`${this.endpoints.GET_PROPOSALS}?projectId=${projectId}`);
  }

  async getAllCategory() {
    return this.get(this.endpoints.GET_ALL_CATEGORY);
  }

  getProposalForCategory(category) {
    return this.get(
      `${this.endpoints.GET_PROPOSALS}?project_category=${category}`,
    );
  }

  async getProposalForPublicDashboard(
    projectId = "",
    taluka = "",
    village = "",
    project_category = "",
  ) {
    let url = `${this.endpoints.GET_PROPOSALS}?projectId=${projectId}`;
    if (taluka) url += `&talukaName=${encodeURIComponent(taluka)}`;
    if (village) url += `&villageName=${encodeURIComponent(village)}`;
    if (project_category)
      url += `&category=${encodeURIComponent(project_category)}`; // ← fixed: was checking `village` again
    return this.get(url);
  }

  // async getMasterAllProject(category = '') {
  //   const url = category
  //     ? `${this.endpoints.GET_MASTER_PROJECT}?category=${category}`
  //     : this.endpoints.GET_MASTER_PROJECT;

  //   return this.get(url);
  // }

  //   async getTalukaVill(projectId) {
  //   return this.get(`${this.endpoints.GET_TALUKAVILLAGE}?projectId=${projectId}`);
  // }

  // getAllCategory() {
  //   return this.api.get(`/getCategory`);
  // }

  getMasterAllProject(category) {
    return this.api.get(`/getMasterAllProject?category=${category}`);
  }

  getTalukaVill(projectId) {
    return this.api.get(`/getTalukaVill?projectId=${projectId}`);
  }

  // getProposalForPublicDashboard(category, taluka = '', village = '') {
  //   return this.api.get(
  //     `/getProposal?category=${category}&taluka=${taluka}&village=${village}`
  //   );
  // }
  // -----
  async postAddProposal(data) {
    return this.post(this.endpoints.ADD_PROPOSAL, data);
  }
  async updateProposal(proposalId, data) {
    return this.patch(`/patchUpdateProposal?proposalId=${proposalId}`, data);
  }
  async getFinalAwardData(projectId,proposalId) {
    return this.get(`/getFinalAwardData?projectId=${projectId}&proposalId=${proposalId}`);
  }
   async postAddFinalAward(projectId,proposalId,data) {
    return this.post(`/postAddFinalAward?project_id=${projectId}&proposal_id=${proposalId}`,data);
  }
  async getProposalById(projectId, proposalId) {
    return this.get(
      `${this.endpoints.GET_PROPOSALS}?projectId=${projectId}&proposalId=${proposalId}`,
    );
  }
  async getAllUserProposal(projectId) {
    return this.get(
      `${this.endpoints.GET_ALL_USER_PROPOSALS}?projectId=${projectId}`,
    );
  }
  async getProposalsByProjectId(projectId) {
    try {
      if (!projectId) {
        throw new Error("Project ID is required");
      }

      const response = await this.get(this.endpoints.GET_PROPOSALS, {
        projectId,
      });

      return {
        status: 200,
        data: response.data || response || [],
      };
    } catch (error) {
      console.error(
        "📋 API Service: Error fetching proposals by project:",
        error,
      );
      throw new Error("Failed to fetch proposals by project");
    }
  }

  async getTracking(projectId, proposalId, page = 1, limit = 10) {
    try {
      if (!projectId || !proposalId) {
        throw new Error("Project ID and Proposal ID are required");
      }

      const response = await this.api.get(this.endpoints.GET_TRACKING, {
        params: {
          projectId,
          proposalId,
          page,
          limit,
        },
      });

      return response;
    } catch (error) {
      console.error("Error fetching tracking data:", error);
      throw error;
    }
  }

  async getTrackingSection23(projectId, proposalId) {
    try {
      if (!projectId || !proposalId) {
        throw new Error("Project ID and Proposal ID are required");
      }

      const response = await this.api.get(this.endpoints.GET_TRACKING, {
        params: {
          projectId,
          proposalId,
        },
      });

      return response.data;
    } catch (error) {
      console.error("Error fetching tracking data:", error);
      throw error;
    }
  }

  //PAP api
  async getPAP(
    projectId,
    proposalId,
    districtName = null,
    talukaName = null,
    villageName = null,
  ) {
    try {
      // Validate required parameters
      if (!projectId || !proposalId) {
        throw new Error("Project ID and Proposal ID are required");
      }

      // Build parameters object
      const params = {
        projectId,
        proposalId,
      };

      // Add optional location parameters only if they exist
      if (districtName) params.districtName = districtName;
      if (talukaName) params.talukaName = talukaName;
      if (villageName) params.villageName = villageName;

      const response = await this.get(this.endpoints.GET_PAP, params);

      // Handle different response structures
      if (response && response.data) {
        return {
          status: 200,
          data: Array.isArray(response.data) ? response.data : [response.data],
          totalCount: Array.isArray(response.data) ? response.data.length : 1,
        };
      } else if (Array.isArray(response)) {
        return {
          status: 200,
          data: response,
          totalCount: response.length,
        };
      } else {
        return {
          status: 200,
          data: response ? [response] : [],
          totalCount: response ? 1 : 0,
        };
      }
    } catch (error) {
      console.error("🌐 API Service: Error fetching PAP data:", error);

      // Enhanced error handling
      if (error.response) {
        const errorMessage =
          error.response.data?.message ||
          error.response.data?.error ||
          `HTTP ${error.response.status}: ${error.response.statusText}`;

        throw new Error(errorMessage);
      } else if (error.request) {
        throw new Error("Network error: Unable to connect to server");
      } else {
        throw new Error(error.message || "Failed to fetch PAP data");
      }
    }
  }
  // Direct Purchase
  // Fetch by project, proposal and location
  async getDirectPurchaseKJP(projectId, proposalId, locationParams = {}) {
    try {
      if (!projectId || !proposalId) {
        throw new Error("Both projectId and proposalId are required");
      }

      const params = {
        projectId,
        proposalId,
      };

      // Conditionally add hierarchical filters
      if (locationParams.distName) {
        params.distName = locationParams.distName;
      }
      if (locationParams.talukaName) {
        params.talukaName = locationParams.talukaName;
      }
      if (locationParams.villName) {
        params.villName = locationParams.villName;
      }

      return await this.get(this.endpoints.GET_DIRECT_PURCHASE_KJP, params);
    } catch (error) {
      console.error("Error in getDirectPurchaseKJP by location:", error);
      throw error;
    }
  }
  // Fetch by purchase ID
  async getDirectPurchaseKJPById(purchaseId) {
    try {
      if (!purchaseId) {
        throw new Error("purchaseId is required");
      }
      const response = await this.api.get(
        `${this.endpoints.GET_DIRECT_PURCHASE_KJP}?purchaseId=${purchaseId}`,
      );
      return response; // raw response, like your getLandHoldingById
    } catch (error) {
      console.error("Error in getDirectPurchaseKJPById:", error);
      throw error;
    }
  }

  // add direct purchase
  async postAddDirectPurchase(data) {
    const payload = {
      project_id: data.project_id || data.projectId,
      proposal_id: data.proposal_id || data.proposalId,
      registration_date: data.registration_date,
      registration_no: data.registration_no,
      owner_name: data.owner_name,
      owner_address: data.owner_address,
      payee_name: data.payee_name,
      payee_address: data.payee_address,
      survey_no: data.survey_no,
      irrigable_area: data.irrigable_area,
      size_rupees: data.size_rupees,
      area_sold: data.area_sold,
      selling_price: data.selling_price,
      hectare_rate: data.hectare_rate,
      hectare_rate_amount: data.hectare_rate_amount,
      size_gat: data.size_gat,
      remarks: data.remarks,
      dist_name: data.dist_name,
      taluka_name: data.taluka_name,
      village_name: data.village_name,
    };

    try {
      const response = await this.api.post(
        this.endpoints.POST_ADD_DIRECT_PURCHASE,
        payload,
        {
          headers: { "Content-Type": "application/json" },
        },
      );
      return response;
    } catch (error) {
      console.error("❌ Error in postAddDirectPurchase:", error);
      throw error;
    }
  }
  //edit direct purchase
  async patchUpdateDirectPurchase(purchaseId, payload) {
    try {
      if (!purchaseId || isNaN(purchaseId)) {
        throw new Error(
          "Invalid or missing purchaseId for patchUpdateDirectPurchase",
        );
      }

      const response = await this.api.patch(
        `${this.endpoints.PATCH_UPDATE_DIRECT_PURCHASE}?purchaseId=${purchaseId}`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      return response;
    } catch (error) {
      console.error("❌ Error in patchUpdateDirectPurchase:", error);
      throw error;
    }
  }

  // ADD Signature PDF
  async postAddSignaturePDF(projectId, proposalId, callerKey, file) {
    const sectionType = SECTION_TYPE_MAP[callerKey];
    if (!sectionType) {
      throw new Error(`Invalid section key: ${callerKey}`);
    }

    const formData = new FormData();
    formData.append("project_id", projectId);
    formData.append("proposal_id", proposalId);
    formData.append("section_type", sectionType);
    formData.append("document", file);

    return this.post(this.endpoints.POST_ADD_SIGNATURE_PDF, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  async getSectionFile(projectId, proposalId, callerKey) {
    const SECTION_TYPE_MAP = {
      parishisht1: "Parishisht-1",
      anusuchi2: "Anusuchi-2",
      parishisht6: "Parishisht-6",
      namukoK: "Namuko-K",
      section11: "Section-11",
      section12: "Section-12",
      section19: "Section-19",
      section15: "Section-15",
      section21: "Section-21",
      section23: "Section-23",
      anusuchi3: "Anusuchi-3",
      report: "Report",
      otherdocuments: "Otherdocuments",
      CoveringLettersSection11: "CoveringLetters-Section11",
      Kalam11: "Kalam11",
      Praruplist: "Praruplist",
      Finallist: "Finallist",
      Namunakdro: "NamunakDro",
      LandReport: "LandReport",
      NamunaB: "NamunaB",
      NamunaA: "NamunaA",
      PrarupReport: "PrarupReport",
      PrarupTippani: "PrarupTippani",
      AkshepReport: "AkshepReport",
      AkshepTappani: "AkshepTappani",
      FinalLand: "FinalLand",
      FinalTippni: "FinalTippni",
      TabaPauti: "TabaPauti",
      TabaPautiTippani: "TabaPautiTippani",
    };
    const sectionType = SECTION_TYPE_MAP[callerKey];
    if (!sectionType) throw new Error(`Invalid section key: ${callerKey}`);

    const url = `${this.endpoints.GET_SECTIONS}?projectId=${projectId}&proposalId=${proposalId}&sectionType=${sectionType}`;
    return this.get(url);
  }

  // Asset Property
  // Tree
  async patchUpdateTree(treeId, payload) {
    try {
      if (!treeId || isNaN(treeId)) {
        throw new Error("Invalid or missing treeId");
      }

      const response = await this.api.patch(
        `${this.endpoints.PATCH_UPDATE_TREE}?treeId=${treeId}`,
        payload,
      );
      return response;
    } catch (error) {
      console.error("❌ Error in patchUpdateTree:", error);
      throw error;
    }
  }

  // Property
  async patchUpdateProperty(propertyId, payload) {
    try {
      if (!propertyId || isNaN(propertyId)) {
        throw new Error("Invalid or missing propertyId");
      }

      const response = await this.api.patch(
        `${this.endpoints.PATCH_UPDATE_PROPERTY}?propertyId=${propertyId}`,
        payload,
      );
      return response;
    } catch (error) {
      console.error("❌ Error in patchUpdateHome:", error);
      throw error;
    }
  }

  // Punarvarshan
  async postPunarvarshan(data) {
    try {
      const response = await this.post(
        `${this.endpoints.POST_PUNARVARSHAN}`,
        data,
      );
      return response;
    } catch (error) {
      console.error("Error updating land holding:", error);
      console.error("Data:", data);

      // Re-throw with more descriptive error
      throw new Error(`Failed to update: ${error.message}`);
    }
  }

  async patchPunarvarshan(id, data) {
    try {
      const response = await this.patch(
        `${this.endpoints.PATCH_UPDATE_PUNARVARSHAN}?punarvarshanId=${id}`,
        data,
      );
      return response;
    } catch (error) {
      console.error("Error updating land holding:", error);
      console.error("Data:", data);

      // Re-throw with more descriptive error
      throw new Error(`Failed to update: ${error.message}`);
    }
  }

  // Covering Letter
  async getAllUserById(userId) {
    return this.get(`${this.endpoints.GET_ALL_USER}?userId=${userId}`);
  }

  async getCoveringLetter(projectId, proposalId, type) {
    try {
      if (!projectId || !proposalId || !type) {
        throw new Error("projectId,proposalId,type is required");
      }

      const response = await this.api.get(
        `${this.endpoints.GET_COVERING_LETTER}?projectId=${projectId}&proposalId=${proposalId}&type=${type}`,
      );
      return response; // raw response, like your getLandHoldingById
    } catch (error) {
      console.error("Error in covering letter:", error);
      throw error;
    }
  }

  async postCoveringLetter(data) {
    try {
      const response = await this.post(
        `${this.endpoints.POST_ADD_COVERING_LETTER}`,
        data,
      );
      return response;
    } catch (error) {
      console.error("Error updating covering letter:", error);
      console.error("Data:", data);

      // Re-throw with more descriptive error
      throw new Error(`Failed to update: ${error.message}`);
    }
  }

  async getLandReportActions() {
    return await this.api.get(this.endpoints.GET_LAND_REPORT_ACTIONS);
  }

  async getTehsildarRecord(projectId, proposalId) {
    if (projectId && proposalId) {
      // return (await this.api.get(this.endpoints.GET_TEHSILDAR_RECORD, {
      //   params: { projectId, proposalId }
      // })).data;
      return this.get(this.endpoints.GET_TEHSILDAR_RECORD, {
        projectId,
        proposalId,
      });
    } else {
      throw new Error("projectId and proposalId are required!");
    }
  }

  async postAddUpdateTehsildarRecord(formData) {
    return (
      await this.api.post(
        this.endpoints.POST_ADD_UPDATE_TEHSILDAR_RECORD,
        formData,
      )
    ).data;
  }

  // Land Beneficiary Letter APIs
  async getLandPlotFamilyPublication(projectId, proposalId) {
    return this.get(this.endpoints.GET_LANDPLOTFAMILY, {
      projectId,
      proposalId,
    });
  }

  async postAddUpdateLandPlotFamilyPublication(data) {
    return this.post(this.endpoints.POST_ADD_UPDATE_LAND_PLOAT_FAMILY, data);
  }

  //FundRequest and receive
  // async postAddFundRequestReceived(data) {
  //   try {
  //     const response = await this.post(`${this.endpoints.POST_ADD_FUND_REQUEST_RECEIVED}`, data);
  //     return response;
  //   } catch (error) {
  //     console.error('Error adding fund request received:', error);
  //     console.error('Data:', data);
  //     throw new Error(`Failed to add fund request: ${error.message}`);
  //   }
  // }

  // async getFundRequestReceived(projectId, proposalId, type) {
  //   if (projectId && proposalId && type) {
  //     return this.get(this.endpoints.GET_FUND_REQUEST_RECEIVED, {
  //       projectId,
  //       proposalId,
  //       type
  //     });
  //   } else {
  //     throw new Error("projectId, proposalId and type are required!");
  //   }
  // }
  // ---- FUND REQUEST RECEIVED ----

  // SECTION 11 - GET (COMMON)
  async getFundRequestReceivedSection11(projectId, proposalId) {
    if (!projectId || !proposalId)
      throw new Error("projectId and proposalId are required!");
    return this.get(this.endpoints.GET_FUND_REQUEST_RECEIVED, {
      projectId,
      proposalId,
      type: "section11",
    });
  }

  // SECTION 19 - GET (COMMON)
  async getFundRequestReceivedSection19(projectId, proposalId) {
    if (!projectId || !proposalId)
      throw new Error("projectId and proposalId are required!");
    return this.get(this.endpoints.GET_FUND_REQUEST_RECEIVED, {
      projectId,
      proposalId,
      type: "section19",
    });
  }

  // SECTION 11 - POST (SEPARATE)
  async postAddFundRequestReceivedSection11(data) {
    if (!data) throw new Error("Data is required!");
    return this.post(
      this.endpoints.POST_ADD_FUND_REQUEST_RECEIVED_SECTION11,
      data,
    );
  }

  // SECTION 19 - POST (SEPARATE)
  async postAddFundRequestReceivedSection19(data) {
    if (!data) throw new Error("Data is required!");
    return this.post(
      this.endpoints.POST_ADD_FUND_REQUEST_RECEIVED_SECTION19,
      data,
    );
  }

  async patchUpdateFundRequestReceived(fundId, data) {
    try {
      if (!fundId) {
        throw new Error("fundId is required!");
      }

      const response = await this.patch(
        `${this.endpoints.PATCH_UPDATE_FUND_REQUEST_RECEIVED}?fundId=${fundId}`,
        data,
      );
      return response;
    } catch (error) {
      console.error("Error updating fund request received:", error);
      throw new Error(`Failed to update fund request: ${error.message}`);
    }
  }

  // Get family details by projectId and proposalId (for listing)
  async getFamilyDetailsByProject(projectId, proposalId) {
    if (!projectId || !proposalId) {
      throw new Error("projectId and proposalId are required!");
    }
    return this.get(this.endpoints.GET_FAMILY_DETAILS, {
      projectId,
      proposalId,
    });
  }

  // Get family details by ownerId (for editing)
  async getFamilyDetailsByOwner(ownerId) {
    if (!ownerId) {
      throw new Error("ownerId is required!");
    }
    return this.get(this.endpoints.GET_FAMILY_DETAILS, { ownerId });
  }

  // ✅ Add Family Details
  async postAddFamilyDetails(familyData) {
    try {
      const formData = new FormData();
      Object.entries(familyData).forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
          formData.append(key, value);
        }
      });

      const response = await this.api.post(
        this.endpoints.POST_FAMILY_DETAILS,
        formData,
      );
      return { status: response.status, data: response.data };
    } catch (error) {
      console.error("❌ Add Family Details Error:", error);
      throw error;
    }
  }

  // ✅ Update Family Details
  async patchUpdateFamilyDetails(familyId, familyData) {
    try {
      const formData = new FormData();
      Object.entries(familyData).forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
          formData.append(key, value);
        }
      });

      const response = await this.api.patch(
        `${this.endpoints.PATCH_FAMILY_DETAILS}?familyId=${familyId}`,
        formData,
      );
      return { status: response.status, data: response.data };
    } catch (error) {
      console.error("❌ Update Family Details Error:", error);
      throw error;
    }
  }
  // ✅ Add Family Property
  async postAddFamilyProperty(propertyData) {
    try {
      const formData = new FormData();
      Object.entries(propertyData).forEach(([k, v]) => {
        if (v !== null && v !== undefined) formData.append(k, v);
      });

      const res = await this.api.post(
        this.endpoints.POST_FAMILY_PROPERTY,
        formData,
      );
      return { status: res.status, data: res.data };
    } catch (err) {
      console.error("❌ Add Family Property Error:", err);
      throw err;
    }
  }

  // ✅ Update Family Property
  async patchUpdateFamilyProperty(propertyId, propertyData) {
    try {
      const formData = new FormData();
      Object.entries(propertyData).forEach(([k, v]) => {
        if (v !== null && v !== undefined) formData.append(k, v);
      });

      const res = await this.api.patch(
        `${this.endpoints.PATCH_UPDATE_FAMILY_PROPERTY}?propertyId=${propertyId}`,
        formData,
      );
      return { status: res.status, data: res.data };
    } catch (err) {
      console.error("❌ Update Family Property Error:", err);
      throw err;
    }
  }

  // Extend Date
  async getExtendDate(projectId, proposalId, type) {
    try {
      const response = await this.api.get(
        `${this.endpoints.GET_PROPOSAL_EXTENDED_DATE}?projectId=${projectId}&proposalId=${proposalId}&type=${type}`,
      );
      return response; // instead of response.data
    } catch (error) {
      console.error("API Error in getGeneralObjectionById:", error);
      throw error;
    }
  }

  async postExtendDate(data) {
    try {
      const response = await this.post(
        `${this.endpoints.POST_PROPOSAL_EXTENDED_DATE}`,
        data,
      );
      return response;
    } catch (error) {
      console.error("Error updating covering letter:", error);
      console.error("Data:", data);

      // Re-throw with more descriptive error
      throw new Error(`Failed to update: ${error.message}`);
    }
  }

  async patchExtendDate(extendId, data) {
    try {
      const response = await this.patch(
        `${this.endpoints.PATCH_PROPOSAL_EXTENDED_DATE}?extendId=${extendId}`,
        data,
      );
      return response;
    } catch (error) {
      console.error("Error updating covering letter:", error);
      console.error("Data:", data);

      // Re-throw with more descriptive error
      throw new Error(`Failed to update: ${error.message}`);
    }
  }

  // Sub users
  async getAllSubUsers() {
    try {
      const response = await this.api.get(`${this.endpoints.GET_SUB_USERS}`);
      return response;
    } catch (error) {
      console.error("API Error in getAllSubUsers:", error);
      throw error;
    }
  }
  async getOwnerCompensation(
    distName,
    talukaName,
    villName,
    projectId,
    proposalId,
  ) {
    try {
      if (!projectId || !proposalId) {
        throw new Error("Project ID and Proposal ID are required");
      }
      const params = {
        projectId,
        proposalId,
      };

      if (distName && distName.trim() !== "") {
        params.distName = distName;
      }
      if (talukaName && talukaName.trim() !== "") {
        params.talukaName = talukaName;
      }
      if (villName && villName.trim() !== "") {
        params.villName = villName;
      }

      const response = await this.get("/getOwnerCompensation", params);

      return {
        status: 200,
        data: response,
      };
    } catch (error) {
      throw new Error("Failed to fetch owner compensation data");
    }
  }

  async getPublicDashboard(params) {
    try {
      const response = await this.api.get("/getPublicDashboard", { params });

      return response;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  }

  async postPublication(payload) {
    return (await this.api.post(this.endpoints.POST_PUBLICATION, payload)).data;
  }

  async getRecentPublications() {
    try {
      const response = await this.api.get(
        `${this.endpoints.GET_RECENT_PUBLICATION}`,
      );
      return response;
    } catch (error) {
      console.error("API Error in getAllSubUsers:", error);
      throw error;
    }
  }

  updateRecentPublication(publicationId, data) {
    return this.patch(
      `${this.endpoints.UPDATE_RECENT_PUBLICATION}?publicationId=${publicationId}`,
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );
  }

  deleteRecentPublication(publicationId) {
    return this.delete(
      `${this.endpoints.DELETE_RECENT_PUBLICATION}?publicationId=${publicationId}`,
    );
  }

  async getContactDetails() {
    return await this.api.get(this.endpoints.GET_CONTACT_DETAILS);
  }
  // -------------------------------------------
  // DRO API CALL
  // -------------------------------------------

  getLandObjectionById(projectId, proposalId) {
    return this.api.get(
      `${this.endpoints.GET_LAND_OBJECTION}?projectId=${projectId}&proposalId=${proposalId}`,
    );
  }

  async postAddObjection(formData) {
    try {
      // formData MUST be FormData
      const response = await this.api.post(
        this.endpoints.POST_LAND_PLOT_OBJECTION,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          timeout: 30000,
        },
      );

      return response.data;
    } catch (error) {
      console.error("❌ postAddObjection failed", error);

      const message =
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Failed to submit objection";

      throw new Error(message);
    }
  }

  async patchUpdateLandPlotObjection(objectionId, objectionData = {}) {
    try {
      if (!objectionData || typeof objectionData !== "object") {
        throw new Error("Invalid objectionData");
      }

      const formData = new FormData();
      Object.entries(objectionData).forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
          formData.append(key, value);
        }
      });

      const response = await this.api.patch(
        "/patchUpdateLandPlotObjection",
        formData,
        { params: { objectionId } },
      );

      return { status: response.status, data: response.data };
    } catch (error) {
      console.error("❌ patchUpdateLandPlotObjection Error:", error);
      throw error;
    }
  }

  async getFamilyDetails(projectId = null, proposalId = null) {
    if (projectId && proposalId) {
      return (
        await this.api.get(this.endpoints.GET_FAMILY_DETAILS, {
          params: { projectId, proposalId },
        })
      ).data;
    } else {
      throw new Error("projectId and proposalId are required!");
    }
  }

  async getPlotFamilyPublication(projectId = null, proposalId = null) {
    if (projectId && proposalId) {
      return (
        await this.api.get(this.endpoints.GET_LAND_PLOT_FAMILY_PUBLICATION, {
          params: { projectId, proposalId },
        })
      ).data;
    } else {
      throw new Error("projectId and proposalId are required!");
    }
  }

  async getLandPlotObjectionPublication(projectId = null, proposalId = null) {
    if (projectId && proposalId) {
      return (
        await this.api.get(this.endpoints.GET_LAND_PLOT_OBJECTION_PUBLICATION, {
          params: { projectId, proposalId },
        })
      ).data;
    } else {
      throw new Error("projectId and proposalId are required!");
    }
  }

  async postAddUpdateLandPlotObjectionPublication(payload = {}) {
    const response = await this.api.post(
      this.endpoints.POST_ADD_UPDATE_LAND_PLOT_OBJECTION_PUBLICATION,
      payload,
    );

    return response; // { status, message, publicationId }
  }

  async getRehabA(projectId, proposalId) {
    const res = await this.api.get(this.endpoints.GET_REHAB_A, {
      params: { projectId, proposalId },
    });

    return res?.data || [];
  }

  // Add Rehabilitation Record
  async postAddRehabA(formData) {
    try {
      const response = await this.post(
        this.endpoints.POST_ADD_REHAB_A,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
      return response;
    } catch (error) {
      console.error("Error in postAddRehabA:", error);
      throw error;
    }
  }

  async patchUpdateRehabA(rehabId, payload = {}) {
    const response = await this.api.patch(
      `${this.endpoints.PATCH_UPDATE_REHAB_A}?rehabId=${rehabId}`,
      payload,
    );
    return response;
  }

  async postAddUpdateTippani(payload) {
    return (
      await this.api.post(this.endpoints.POST_ADD_UPDATE_TIPPANI, payload)
    ).data;
  }

  async getTippani(projectId = null, proposalId = null, tippaniType = null) {
    if (projectId && proposalId && tippaniType) {
      return (
        await this.api.get(this.endpoints.GET_TIPPANI, {
          params: { projectId, proposalId, tippaniType },
        })
      ).data;
    } else {
      throw new Error("projectId, proposalId and tippaniType are required!");
    }
  }

  async getLandAllocationReport(projectId = null, proposalId = null) {
    if (projectId && proposalId) {
      return (
        await this.api.get(this.endpoints.GET_LAND_ALLOCATION_REPORT, {
          params: { projectId, proposalId },
        })
      ).data;
    } else {
      throw new Error("projectId and proposalId are required!");
    }
  }

  async postAddUpdateTabapavti(payload) {
    return (
      await this.api.post(this.endpoints.POST_ADD_UPDATE_TABAPAVTI, payload)
    ).data;
  }

  async getTabapavti(projectId = null, proposalId = null) {
    if (projectId && proposalId) {
      return (
        await this.api.get(this.endpoints.GET_TABAPAVTI, {
          params: { projectId, proposalId },
        })
      ).data;
    } else {
      throw new Error("projectId and proposalId are required!");
    }
  }

  async postAddUpdateTabapavtiTippani(payload) {
    return (
      await this.api.post(
        this.endpoints.POST_ADD_UPDATE_TABAPAVTI_TIPPANI,
        payload,
      )
    ).data;
  }

  async getTabapavtiTippani(projectId = null, proposalId = null) {
    if (!projectId || !proposalId) {
      throw new Error("projectId and proposalId are required!");
    }
    return (
      await this.api.get(this.endpoints.GET_TABAPAVTI_TIPPANI, {
        params: { projectId, proposalId },
      })
    ).data;
  }

  async getAllSearch(paramsObj) {
    const params = new URLSearchParams();
    Object.entries(paramsObj).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        params.append(key, value);
      }
    });
    // Construct URL with query parameters
    return this.get(`${this.endpoints.GET_ALL_SEARCH}?${params.toString()}`);
  }

  async getNotification() {
    return this.get(this.endpoints.GET_NOTIFICATION);
  }

  async patchUpdateAllNotification() {
    return this.patch(`${this.endpoints.PATCH_UPDATE_ALL_NOTIFICATION}`);
  }

  async patchUpdateSingleNotification(notificationId) {
    return this.patch(
      `${this.endpoints.PATCH_UPDATE_SINGLE_NOTIFICATION}?notificationId=${notificationId}`,
    );
  }

  // -------------------------------------------
  // RAILWAY API CALL
  // -------------------------------------------

  //For Railway

  //Add Proposal
  async postAddRailwayProposal(data) {
    return this.post(this.endpoints.ADD_RAILWAY_PROPOSAL, data);
  }

  //Get All Proposal
  async getRailwayProposal(projectId) {
    return this.get(
      `${this.endpoints.GET__RAILWAY_PROPOSALS}?projectId=${projectId}`,
    );
  }

  //Get Proposal By ID
  async getRailwayProposalById(projectId, proposalId) {
    return this.get(
      `${this.endpoints.GET__RAILWAY_PROPOSALS}?projectId=${projectId}&proposalId=${proposalId}`,
    );
  }

  //Add LandHolding
  async postAddRailwayLandHolding(data) {
    const payload = {
      project_id: data.projectId || data.project_id,
      proposal_id: data.proposalId || data.proposal_id,
      village_name: data.village_name,
      survey_no: data.surveyNo || data.survey_no,
      aqr_area: data.aqrArea || data.aqr_area,
      area_unit_id: data.areaUnitId || data.area_unit_id || "ACRE",
      landholder_name: data.landholderName || data.landholder_name,
      survey_type: data.surveyType || data.survey_type || "Revenue",
      irrigable_type: data.irrigableType || data.irrigable_type,
      irrigable_area: data.irrigableArea || data.irrigable_area,
      non_irrigable_area: data.nonIrrigableArea || data.non_irrigable_area,
      total_area: data.totalArea || data.total_area,
      north: data.north || data.north,
      east: data.east || data.east,
      west: data.west || data.west,
      south: data.south || data.south,
      is_active:
        data.isActive !== undefined
          ? data.isActive
          : data.is_active !== undefined
            ? data.is_active
            : 1,
      land_no: data.landNo || data.land_no,
      dist_name: data.dist_name,
      taluka_name: data.taluka_name,
      land_holding_type: data.land_holding_type,
    };

    try {
      const response = await this.api.post(
        this.endpoints.POST_RAILWAY_ADD_LANDHOLDING,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      return response;
    } catch (error) {
      console.error("Add landholding failed", error);
      console.error("Error details:", error.response?.data || error.message);
      throw error;
    }
  }

  //Get LandHolding
  async getRailwayLandHolding(projectId = null, locationParams = {}) {
    try {
      const params = {};

      // Add projectId if provided
      if (projectId) {
        params.projectId = projectId;
      }
      // Add proposalId if provided
      if (locationParams.proposalId) {
        params.proposalId = locationParams.proposalId;
      }

      // Add location parameters if provided
      if (locationParams.distNo) {
        params.distNo = locationParams.distNo;
      }
      if (locationParams.talukaNo) {
        params.talukaNo = locationParams.talukaNo;
      }
      if (locationParams.villageNo) {
        params.villageNo = locationParams.villageNo;
      }

      return this.get(this.endpoints.GET_RAILWAY_LANDHOLDING, params);
    } catch (error) {
      console.error("Error in getLandHolding:", error);
      throw error;
    }
  }

  //Get LandHolding By ID
  async getRailwayLandHoldingById(landId) {
    try {
      const response = await this.api.get(
        `${this.endpoints.GET_RAILWAY_LANDHOLDING}?landId=${landId}`,
      );
      return response; // instead of response.data
    } catch (error) {
      console.error("API Error in getGeneralObjectionById:", error);
      throw error;
    }
  }

  //Edit LandHolding
  async updateRailwayLandHolding(landId, data) {
    try {
      // Validate landId before making the API call
      if (!landId || landId === "undefined" || landId === undefined) {
        throw new Error("Invalid landId provided for update operation");
      }

      const response = await this.patch(
        `${this.endpoints.UPDATE_RAILWAY_LANDHOLDING}?landId=${landId}`,
        data,
      );

      // Check if response is ok
      if (response.status !== 200 && response.status !== 204) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
      const result = response.data;

      return {
        ok: true,
        data: result,
        status: response.status,
      };
    } catch (error) {
      console.error("Error updating land holding:", error);
      console.error("LandId:", landId);
      console.error("Data:", data);

      // Re-throw with more descriptive error
      throw new Error(`Failed to update landholding: ${error.message}`);
    }
  }

  //Delete LandHolding
  async deleteRailwayLandHolding(landId) {
    return this.delete(
      `${this.endpoints.DELETE_RAILWAY_LANDHOLDING}?landId=${landId}`,
    );
  }

  // Parishist A notice
  async getRailwayParishistANotice(projectId, proposalId) {
    try {
      const response = await this.api.get(
        `${this.endpoints.GET_RAILWAY_PARISHIST_A_NOTICE}?projectId=${projectId}&proposalId=${proposalId}`,
      );
      return response;
    } catch (error) {
      console.error("API Error in getGeneralObjectionById:", error);
      throw error;
    }
  }

  async postAddUpdateParishistANotice(data) {
    try {
      const response = await this.api.post(
        this.endpoints.POST_RAILWAY_ADD_UPDATE_PARISHIST_A_NOTICE,
        data,
      );
      return response;
    } catch (error) {
      console.error("Add landholding failed", error);
      console.error("Error details:", error.response?.data || error.message);
      throw error;
    }
  }

  // E Work Details
  async getRailwayEWorkDetails(projectId, proposalId) {
    try {
      const response = await this.api.get(
        `${this.endpoints.GET_RAILWAY_E_Work_Details}?projectId=${projectId}&proposalId=${proposalId}`,
      );
      return response;
    } catch (error) {
      console.error("API Error in getGeneralObjectionById:", error);
      throw error;
    }
  }

  async postAddUpdateEWorkDetails(data) {
    try {
      const response = await this.api.post(
        this.endpoints.POST_RAILWAY_ADD_UPDATE_E_Work_Details,
        data,
      );
      return response;
    } catch (error) {
      console.error("Add landholding failed", error);
      console.error("Error details:", error.response?.data || error.message);
      throw error;
    }
  }

  //Update Measurement
  async patchUpdateRailwayMeasurement(measurementId, measurementData) {
    try {
      const formData = new FormData();

      // Add all fields to FormData
      Object.entries(measurementData).forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
          formData.append(key, value);
        }
      });

      // ✅ Important: send measurementId as a query param named exactly 'measureId'
      const response = await this.api.patch(
        "/patchUpdateRailwayMeasurement",
        formData,
        {
          params: { measureId: measurementId },
        },
      );

      return {
        status: response.status,
        data: response.data,
      };
    } catch (error) {
      console.error("❌ Update Measurement Error:", error);
      throw error;
    }
  }

  //Add Measurement
  async addRailwayMeasurement(measurementData) {
    try {
      const response = await this.api.post(
        this.endpoints.ADD_RAILWAY_MEASUREMENT,
        measurementData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      return response;
    } catch (error) {
      if (error.name === "TypeError" && error.message.includes("fetch")) {
        throw new Error("Network error: Unable to connect to server");
      }
      throw error;
    }
  }

  //Tracking
  async postRailwayTrackingCollector(data, type = "Collector") {
    const url = `${this.endpoints.POST_RAILWAY_TRACKING}?type=${type}`;
    return this.post(url, data);
  }

  async postRailwayTrackingLAO(data, type = "LAO") {
    const url = `${this.endpoints.POST_RAILWAY_TRACKING}?type=${type}`;
    return this.post(url, data);
  }

  async postRailwayTrackingSamanvay(data, type = "Samanvay") {
    const url = `${this.endpoints.POST_RAILWAY_TRACKING}?type=${type}`;
    return this.post(url, data);
  }

  //Send Button
  async getRailwaySamanvayButton(projectId, proposalId, type = "Samanvay") {
    if (!projectId || !proposalId) {
      throw new Error("Missing projectId or proposalId");
    }
    const url = `${this.endpoints.GET_RAILWAY_BUTTON_DISABLE}?project_id=${projectId}&proposal_id=${proposalId}&type=${type}`;
    return this.get(url);
  }

  async getRailwayCollectorButton(projectId, proposalId, type = "Collector") {
    const url = `${this.endpoints.GET_RAILWAY_BUTTON_DISABLE}?project_id=${projectId}&proposal_id=${proposalId}&type=${type}`;
    return this.get(url);
  }

  async getRailwayLAOButton(projectId, proposalId, type = "LAO") {
    const url = `${this.endpoints.GET_RAILWAY_BUTTON_DISABLE}?project_id=${projectId}&proposal_id=${proposalId}&type=${type}`;
    return this.get(url);
  }

  //Publish Proposal
  async getRailwayProposalPublish(projectId, proposalId) {
    try {
      const response = await this.api.get(
        `${this.endpoints.GET_RAILWAY_PROPOSAL_PUBLISH}?projectId=${projectId}&proposalId=${proposalId}`,
      );
      return response; // instead of response.data
    } catch (error) {
      console.error("API Error in getGeneralObjectionById:", error);
      throw error;
    }
  }

  async getfetchRailwayLAOPublishButton(
    projectId,
    proposalId,
    type = "LAOPublish",
  ) {
    if (!projectId || !proposalId) {
      throw new Error("Missing projectId or proposalId");
    }
    const url = `${this.endpoints.GET_RAILWAY_BUTTON_DISABLE}?project_id=${projectId}&proposal_id=${proposalId}&type=${type}`;
    return this.get(url);
  }

  async updateRailwayProposalPublish(proposalId, data) {
    try {
      // Validate landId before making the API call
      if (
        !proposalId ||
        proposalId === "undefined" ||
        proposalId === undefined
      ) {
        throw new Error("Invalid landId provided for update operation");
      }

      const response = await this.patch(
        `${this.endpoints.UPDATE_RAILWAY_PROPOSAL_PUBLISH}?proposalId=${proposalId}`,
        data,
      );

      // Check if response is ok
      if (response.status !== 200 && response.status !== 204) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
      const result = response.data;

      return {
        ok: true,
        data: result,
        status: response.status,
      };
    } catch (error) {
      console.error("Error updating land holding:", error);
      console.error("LanProposal IddId:", proposalId);
      console.error("Data:", data);

      // Re-throw with more descriptive error
      throw new Error(`Failed to update landholding: ${error.message}`);
    }
  }

  //Extended Date

  async postRailwayTrackingbackToLaoExtentedDate(data, type = "LAOExtendDate") {
    const url = `${this.endpoints.POST_RAILWAY_TRACKING}?type=${type}`;
    return this.post(url, data);
  }

  async postRailwayTrackingCollectorExtentedDate(
    data,
    type = "CollectorExtendDate",
  ) {
    const url = `${this.endpoints.POST_RAILWAY_TRACKING}?type=${type}`;
    return this.post(url, data);
  }

  async postRailwayTrackingSamanvayExtentedDate(
    data,
    type = "SamanvayExtendDate",
  ) {
    const url = `${this.endpoints.POST_RAILWAY_TRACKING}?type=${type}`;
    return this.post(url, data);
  }

  async postRailwayTrackingSLR(data, type = "SLR") {
    const url = `${this.endpoints.POST_RAILWAY_TRACKING}?type=${type}`;
    return this.post(url, data);
  }

  async postRailwayTrackingTehsildar(data, type = "TehsildarReport") {
    const url = `${this.endpoints.POST_RAILWAY_TRACKING}?type=${type}`;
    return this.post(url, data);
  }

  async getRailwayDSLRButton(projectId, proposalId, type = "SLR") {
    if (!projectId || !proposalId) {
      throw new Error("Missing projectId or proposalId");
    }
    const url = `${this.endpoints.GET_RAILWAY_BUTTON_DISABLE}?project_id=${projectId}&proposal_id=${proposalId}&type=${type}`;
    return this.get(url);
  }



  async getRailwaySamanvayExtentedDateButton(
    projectId,
    proposalId,
    type = "SamanvayExtendDate",
  ) {
    const url = `${this.endpoints.GET_RAILWAY_BUTTON_DISABLE}?project_id=${projectId}&proposal_id=${proposalId}&type=${type}`;
    return this.get(url);
  }

  async getRailwayCollectorExtentedDateButton(
    projectId,
    proposalId,
    type = "CollectorExtendDate",
  ) {
    const url = `${this.endpoints.GET_RAILWAY_BUTTON_DISABLE}?project_id=${projectId}&proposal_id=${proposalId}&type=${type}`;
    return this.get(url);
  }

  async getRailwayLaoExtentedDateButton(
    projectId,
    proposalId,
    type = "LAOExtendDate",
  ) {
    const url = `${this.endpoints.GET_RAILWAY_BUTTON_DISABLE}?project_id=${projectId}&proposal_id=${proposalId}&type=${type}`;
    return this.get(url);
  }

  async postRailwayTrackingSamanvaySection11(data, type = "SamanvaySection11") {
    const url = `${this.endpoints.POST_RAILWAY_TRACKING}?type=${type}`;
    return this.post(url, data);
  }

  async postRailwayTrackingCollectorSection11(
    data,
    type = "CollectorSection11",
  ) {
    const url = `${this.endpoints.POST_RAILWAY_TRACKING}?type=${type}`;
    return this.post(url, data);
  }

  async postRailwayTrackingLAOPublish(data, type = "LAOPublish") {
    const url = `${this.endpoints.POST_RAILWAY_TRACKING}?type=${type}`;
    return this.post(url, data);
  }

  async getRailwayfetchSamanvayButtonSection11(
    projectId,
    proposalId,
    type = "SamanvaySection11",
  ) {
    if (!projectId || !proposalId) {
      throw new Error("Missing projectId or proposalId");
    }
    const url = `${this.endpoints.GET_RAILWAY_BUTTON_DISABLE}?project_id=${projectId}&proposal_id=${proposalId}&type=${type}`;
    return this.get(url);
  }

  async getRailwayfetchCollectorButtonSection11(
    projectId,
    proposalId,
    type = "CollectorSection11",
  ) {
    if (!projectId || !proposalId) {
      throw new Error("Missing projectId or proposalId");
    }
    const url = `${this.endpoints.GET_RAILWAY_BUTTON_DISABLE}?project_id=${projectId}&proposal_id=${proposalId}&type=${type}`;
    return this.get(url);
  }


  async getRailwayfetchLAOPublishButton(
    projectId,
    proposalId,
    type = "LAOPublish",
  ) {
    if (!projectId || !proposalId) {
      throw new Error("Missing projectId or proposalId");
    }
    const url = `${this.endpoints.GET_RAILWAY_BUTTON_DISABLE}?project_id=${projectId}&proposal_id=${proposalId}&type=${type}`;
    return this.get(url);
  }

  async updateRailwayProposal(proposalId, data) {
    return this.patch(
      `/patchUpdateRailwayProposal?proposalId=${proposalId}`,
      data,
    );
  }

  //Mesurement List
  async getAllRailwayOwner(
    districtName = null,
    talukaName = null,
    villageName = null,
    projectId = null,
    proposalId = null,
  ) {
    try {
      if (!projectId && !proposalId) {
        throw new Error("At least projectId or proposalId must be provided");
      }

      const params = {};
      if (districtName) params.districtName = districtName;
      if (talukaName) params.talukaName = talukaName;
      if (villageName) params.villageName = villageName;
      if (projectId) params.projectId = projectId;
      if (proposalId) params.proposalId = proposalId;

      // Use axios directly to get full response
      const response = await axios.get(
        `${this.api.defaults.baseURL}/getRailwayAllOwner`,
        {
          params,
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
            ...this.api.defaults.headers,
          },
        },
      );

      return {
        status: response.status,
        data: response.data.landAcquisition || [],
      };
    } catch (error) {
      console.error("Error in getAllOwner API:", error);
      throw error;
    }
  }

  async patchRailwayUpdateLand(landAcqId, measurementData) {
    try {
      const formData = new FormData();

      // Add all fields to FormData
      Object.entries(measurementData).forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
          formData.append(key, value);
        }
      });

      // ✅ Important: send measurementId as a query param named exactly 'measureId'
      const response = await this.api.patch(
        "/patchUpdateRailwayMeasurement",
        formData,
        {
          params: { landAcqId: landAcqId }, // <-- correct!
        },
      );

      return {
        status: response.status,
        data: response.data,
      };
    } catch (error) {
      console.error("❌ Update Measurement Error:", error);
      throw error;
    }
  }

  async getRailwayAssignSurveyorButton(
    projectId,
    proposalId,
    type = "Surveyor",
  ) {
    const url = `${this.endpoints.GET_RAILWAY_BUTTON_DISABLE}?project_id=${projectId}&proposal_id=${proposalId}&type=${type}`;
    return this.get(url);
  }

  async getRailwayAgencyButton(projectId, proposalId, type = "Agency") {
    const url = `${this.endpoints.GET_RAILWAY_BUTTON_DISABLE}?project_id=${projectId}&proposal_id=${proposalId}&type=${type}`;
    return this.get(url);
  }

  async getRailwayAssignBackToDSLRButton(projectId, proposalId, type = "SLRV") {
    const url = `${this.endpoints.GET_RAILWAY_BUTTON_DISABLE}?project_id=${projectId}&proposal_id=${proposalId}&type=${type}`;
    return this.get(url);
  }

  async postRailwayTrackingSurveyor(data, type = "Surveyor") {
    const url = `${this.endpoints.POST_RAILWAY_TRACKING}?type=${type}`;
    return this.post(url, data);
  }

  async postRailwayTrackingbacktoLao(data, type = "LAOV") {
    const url = `${this.endpoints.POST_RAILWAY_TRACKING}?type=${type}`;
    return this.post(url, data);
  }

  async postRailwayTrackingbacktoSlr(data, type = "SLRV") {
    const url = `${this.endpoints.POST_RAILWAY_TRACKING}?type=${type}`;
    return this.post(url, data);
  }

  async postRailwayTrackingAgency(data, type) {
    const url = `${this.endpoints.POST_RAILWAY_TRACKING}?type=${type}`;
    return this.post(url, data);
  }

  async getRailwayMeasurementByOwnerID(measurementId) {
    try {
      const response = await this.api.get(
        this.endpoints.GET_RAILWAY_MEASUREMENT_OWNER_ID,
        {
          params: { measurementId },
        },
      );
      return response.data; // Returns { status: 200, data: {...} }
    } catch (error) {
      console.error("Error in getMeasurementByOwnerID:", error);
      throw error;
    }
  }

  async getRailwaySendBackToLAOButton(projectId, proposalId, type = "LAOV") {
    const url = `${this.endpoints.GET_RAILWAY_BUTTON_DISABLE}?project_id=${projectId}&proposal_id=${proposalId}&type=${type}`;
    return this.get(url);
  }

  async getRailwayPAP(
    projectId,
    proposalId,
    districtName = null,
    talukaName = null,
    villageName = null,
  ) {
    try {
      // Validate required parameters
      if (!projectId || !proposalId) {
        throw new Error("Project ID and Proposal ID are required");
      }

      // Build parameters object
      const params = {
        projectId,
        proposalId,
      };

      // Add optional location parameters only if they exist
      if (districtName) params.districtName = districtName;
      if (talukaName) params.talukaName = talukaName;
      if (villageName) params.villageName = villageName;

      const response = await this.get(this.endpoints.GET_RAILWAY_PAP, params);

      // Handle different response structures
      if (response && response.data) {
        return {
          status: 200,
          data: Array.isArray(response.data) ? response.data : [response.data],
          totalCount: Array.isArray(response.data) ? response.data.length : 1,
        };
      } else if (Array.isArray(response)) {
        return {
          status: 200,
          data: response,
          totalCount: response.length,
        };
      } else {
        return {
          status: 200,
          data: response ? [response] : [],
          totalCount: response ? 1 : 0,
        };
      }
    } catch (error) {
      console.error("🌐 API Service: Error fetching PAP data:", error);

      // Enhanced error handling
      if (error.response) {
        const errorMessage =
          error.response.data?.message ||
          error.response.data?.error ||
          `HTTP ${error.response.status}: ${error.response.statusText}`;

        throw new Error(errorMessage);
      } else if (error.request) {
        throw new Error("Network error: Unable to connect to server");
      } else {
        throw new Error(error.message || "Failed to fetch PAP data");
      }
    }
  }

  // -------------------------------------------
  // Highway API CALL
  // -------------------------------------------

  //For Highway

  //Add Proposal
  async postAddHighwayProposal(data) {
    return this.post(this.endpoints.ADD_HIGHWAY_PROPOSAL, data);
  }

  //Get All Proposal
  async getHighwayProposal(projectId) {
    return this.get(
      `${this.endpoints.GET_HIGHWAY_PROPOSALS}?projectId=${projectId}`,
    );
  }

  //Get Proposal By ID
  async getHighwayProposalById(projectId, proposalId) {
    return this.get(
      `${this.endpoints.GET_HIGHWAY_PROPOSALS}?projectId=${projectId}&proposalId=${proposalId}`,
    );
  }

  //For Highway LandHolding
  //Add LandHolding
  async postAddHighwayLandHolding(data) {
    const payload = {
      project_id: data.projectId || data.project_id,
      proposal_id: data.proposalId || data.proposal_id,
      village_name: data.village_name,
      survey_no: data.surveyNo || data.survey_no,
      aqr_area: data.aqrArea || data.aqr_area,
      area_unit_id: data.areaUnitId || data.area_unit_id || "ACRE",
      landholder_name: data.landholderName || data.landholder_name,
      survey_type: data.surveyType || data.survey_type || "Revenue",
      irrigable_type: data.irrigableType || data.irrigable_type,
      irrigable_area: data.irrigableArea || data.irrigable_area,
      non_irrigable_area: data.nonIrrigableArea || data.non_irrigable_area,
      total_area: data.totalArea || data.total_area,
      north: data.north || data.north,
      east: data.east || data.east,
      west: data.west || data.west,
      south: data.south || data.south,
      is_active:
        data.isActive !== undefined
          ? data.isActive
          : data.is_active !== undefined
            ? data.is_active
            : 1,
      land_no: data.landNo || data.land_no,
      dist_name: data.dist_name,
      taluka_name: data.taluka_name,
      land_holding_type: data.land_holding_type,
    };

    try {
      const response = await this.api.post(
        this.endpoints.POST_HIGHWAY_ADD_LANDHOLDING,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      return response;
    } catch (error) {
      console.error("Add landholding failed", error);
      console.error("Error details:", error.response?.data || error.message);
      throw error;
    }
  }

  //Get LandHolding
  async getHighwayLandHolding(projectId = null, locationParams = {}) {
    try {
      const params = {};

      // Add projectId if provided
      if (projectId) {
        params.projectId = projectId;
      }
      // Add proposalId if provided
      if (locationParams.proposalId) {
        params.proposalId = locationParams.proposalId;
      }

      // Add location parameters if provided
      if (locationParams.distNo) {
        params.distNo = locationParams.distNo;
      }
      if (locationParams.talukaNo) {
        params.talukaNo = locationParams.talukaNo;
      }
      if (locationParams.villageNo) {
        params.villageNo = locationParams.villageNo;
      }

      return this.get(this.endpoints.GET_HIGHWAY_LANDHOLDING, params);
    } catch (error) {
      console.error("Error in getLandHolding:", error);
      throw error;
    }
  }

  //Get LandHolding By ID
  async getHighwayLandHoldingById(landId) {
    try {
      const response = await this.api.get(
        `${this.endpoints.GET_HIGHWAY_LANDHOLDING}?landId=${landId}`,
      );
      return response; // instead of response.data
    } catch (error) {
      console.error("API Error in getGeneralObjectionById:", error);
      throw error;
    }
  }

  //Edit LandHolding
  async updateHighwayLandHolding(landId, data) {
    try {
      // Validate landId before making the API call
      if (!landId || landId === "undefined" || landId === undefined) {
        throw new Error("Invalid landId provided for update operation");
      }

      const response = await this.patch(
        `${this.endpoints.UPDATE_HIGHWAY_LANDHOLDING}?landId=${landId}`,
        data,
      );

      // Check if response is ok
      if (response.status !== 200 && response.status !== 204) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
      const result = response.data;

      return {
        ok: true,
        data: result,
        status: response.status,
      };
    } catch (error) {
      console.error("Error updating land holding:", error);
      console.error("LandId:", landId);
      console.error("Data:", data);

      // Re-throw with more descriptive error
      throw new Error(`Failed to update landholding: ${error.message}`);
    }
  }

  //Delete LandHolding
  async deleteHighwayLandHolding(landId) {
    return this.delete(
      `${this.endpoints.DELETE_HIGHWAY_LANDHOLDING}?landId=${landId}`,
    );
  }

  //Update Measurement
  async patchUpdateHighwayMeasurement(measurementId, measurementData) {
    try {
      const formData = new FormData();

      // Add all fields to FormData
      Object.entries(measurementData).forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
          formData.append(key, value);
        }
      });

      // ✅ Important: send measurementId as a query param named exactly 'measureId'
      const response = await this.api.patch(
        "/patchUpdateHighwayMeasurement",
        formData,
        {
          params: { measureId: measurementId },
        },
      );

      return {
        status: response.status,
        data: response.data,
      };
    } catch (error) {
      console.error("❌ Update Measurement Error:", error);
      throw error;
    }
  }

  //Add Measurement
  async addHighwayMeasurement(measurementData) {
    try {
      const response = await this.api.post(
        this.endpoints.ADD_HIGHWAY_MEASUREMENT,
        measurementData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      return response;
    } catch (error) {
      if (error.name === "TypeError" && error.message.includes("fetch")) {
        throw new Error("Network error: Unable to connect to server");
      }
      throw error;
    }
  }

  // LAO Button Disable-Highway
  async getHighwayLAOButton(projectId, proposalId, type = "LAO") {
    const url = `${this.endpoints.GET_HIGHWAY_BUTTON_DISABLE}?project_id=${projectId}&proposal_id=${proposalId}&type=${type}`;
    return this.get(url);
  }

  async postHighwayTrackingLAO(data, type = "LAO") {
    const url = `${this.endpoints.POST_HIGHWAY_TRACKING}?type=${type}`;
    return this.post(url, data);
  }
  async postHighwayTrackingSamanvay(data, type = "Samanvay") {
    const url = `${this.endpoints.POST_HIGHWAY_TRACKING}?type=${type}`;
    return this.post(url, data);
  }
  async postHighwayTrackingCollector(data, type = "Collector") {
    const url = `${this.endpoints.POST_HIGHWAY_TRACKING}?type=${type}`;
    return this.post(url, data);
  }

  async getHighwaySamanvayButton(projectId, proposalId, type = "Samanvay") {
    if (!projectId || !proposalId) {
      throw new Error("Missing projectId or proposalId");
    }
    const url = `${this.endpoints.GET_HIGHWAY_BUTTON_DISABLE}?project_id=${projectId}&proposal_id=${proposalId}&type=${type}`;
    return this.get(url);
  }

  async getHighwayCollectorButton(projectId, proposalId, type = "Collector") {
    const url = `${this.endpoints.GET_HIGHWAY_BUTTON_DISABLE}?project_id=${projectId}&proposal_id=${proposalId}&type=${type}`;
    return this.get(url);
  }

  //Highway Publish Proposal
  async getHighwayfetchLAOPublishButton(
    projectId,
    proposalId,
    type = "LAOPublish",
  ) {
    if (!projectId || !proposalId) {
      throw new Error("Missing projectId or proposalId");
    }
    const url = `${this.endpoints.GET_HIGHWAY_BUTTON_DISABLE}?project_id=${projectId}&proposal_id=${proposalId}&type=${type}`;
    return this.get(url);
  }

  async updateHighwayProposalPublish(proposalId, data) {
    try {
      // Validate landId before making the API call
      if (
        !proposalId ||
        proposalId === "undefined" ||
        proposalId === undefined
      ) {
        throw new Error("Invalid landId provided for update operation");
      }

      const response = await this.patch(
        `${this.endpoints.UPDATE_HIGHWAY_PROPOSAL_PUBLISH}?proposalId=${proposalId}`,
        data,
      );

      // Check if response is ok
      if (response.status !== 200 && response.status !== 204) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
      const result = response.data;

      return {
        ok: true,
        data: result,
        status: response.status,
      };
    } catch (error) {
      console.error("Error updating land holding:", error);
      console.error("LanProposal IddId:", proposalId);
      console.error("Data:", data);

      // Re-throw with more descriptive error
      throw new Error(`Failed to update landholding: ${error.message}`);
    }
  }

  async getHighwayProposalPublish(projectId, proposalId) {
    try {
      const response = await this.api.get(
        `${this.endpoints.GET_HIGHWAY_PROPOSALS_PUBLISH}?projectId=${projectId}&proposalId=${proposalId}`,
      );
      return response; // instead of response.data
    } catch (error) {
      console.error("API Error in getGeneralObjectionById:", error);
      throw error;
    }
  }

  async postHighwayTrackingCollectorExtentedDate(
    data,
    type = "CollectorExtendDate",
  ) {
    const url = `${this.endpoints.POST_HIGHWAY_TRACKING}?type=${type}`;
    return this.post(url, data);
  }

  async postHighwayTrackingbackToLaoExtentedDate(data, type = "LAOExtendDate") {
    const url = `${this.endpoints.POST_HIGHWAY_TRACKING}?type=${type}`;
    return this.post(url, data);
  }

  async postHighwayTrackingSamanvayExtentedDate(
    data,
    type = "SamanvayExtendDate",
  ) {
    const url = `${this.endpoints.POST_HIGHWAY_TRACKING}?type=${type}`;
    return this.post(url, data);
  }

  async postHighwayTrackingSLR(data, type = "SLR") {
    const url = `${this.endpoints.POST_HIGHWAY_TRACKING}?type=${type}`;
    return this.post(url, data);
  }

  async getHighwayDSLRButton(projectId, proposalId, type = "SLR") {
    if (!projectId || !proposalId) {
      throw new Error("Missing projectId or proposalId");
    }
    const url = `${this.endpoints.GET_HIGHWAY_BUTTON_DISABLE}?project_id=${projectId}&proposal_id=${proposalId}&type=${type}`;
    return this.get(url);
  }



  async getHighwaySamanvayExtentedDateButton(
    projectId,
    proposalId,
    type = "SamanvayExtendDate",
  ) {
    const url = `${this.endpoints.GET_HIGHWAY_BUTTON_DISABLE}?project_id=${projectId}&proposal_id=${proposalId}&type=${type}`;
    return this.get(url);
  }

  async getHighwayCollectorExtentedDateButton(
    projectId,
    proposalId,
    type = "CollectorExtendDate",
  ) {
    const url = `${this.endpoints.GET_HIGHWAY_BUTTON_DISABLE}?project_id=${projectId}&proposal_id=${proposalId}&type=${type}`;
    return this.get(url);
  }

  async getHighwayLaoExtentedDateButton(
    projectId,
    proposalId,
    type = "LAOExtendDate",
  ) {
    const url = `${this.endpoints.GET_HIGHWAY_BUTTON_DISABLE}?project_id=${projectId}&proposal_id=${proposalId}&type=${type}`;
    return this.get(url);
  }

  async postHighwayTrackingSamanvaySection11(data, type = "SamanvaySection11") {
    const url = `${this.endpoints.POST_HIGHWAY_TRACKING}?type=${type}`;
    return this.post(url, data);
  }

  async postHighwayTrackingCollectorSection11(
    data,
    type = "CollectorSection11",
  ) {
    const url = `${this.endpoints.POST_HIGHWAY_TRACKING}?type=${type}`;
    return this.post(url, data);
  }

  async postHighwayTrackingLAOPublish(data, type = "LAOPublish") {
    const url = `${this.endpoints.POST_HIGHWAY_TRACKING}?type=${type}`;
    return this.post(url, data);
  }

  async getHighwayfetchSamanvayButtonSection11(
    projectId,
    proposalId,
    type = "SamanvaySection11",
  ) {
    if (!projectId || !proposalId) {
      throw new Error("Missing projectId or proposalId");
    }
    const url = `${this.endpoints.GET_HIGHWAY_BUTTON_DISABLE}?project_id=${projectId}&proposal_id=${proposalId}&type=${type}`;
    return this.get(url);
  }

  async getHighwayfetchCollectorButtonSection11(
    projectId,
    proposalId,
    type = "CollectorSection11",
  ) {
    if (!projectId || !proposalId) {
      throw new Error("Missing projectId or proposalId");
    }
    const url = `${this.endpoints.GET_HIGHWAY_BUTTON_DISABLE}?project_id=${projectId}&proposal_id=${proposalId}&type=${type}`;
    return this.get(url);
  }

  async updateHighwayProposal(proposalId, data) {
    return this.patch(
      `/patchUpdateHighwayProposal?proposalId=${proposalId}`,
      data,
    );
  }

  async postHighwayTrackingTehsildar(data, type = "TehsildarReport") {
    const url = `${this.endpoints.POST_HIGHWAY_TRACKING}?type=${type}`;
    return this.post(url, data);
  }

  //Highway JMR
  async patchHighwayUpdateLand(landAcqId, measurementData) {
    try {
      const formData = new FormData();

      // Add all fields to FormData
      Object.entries(measurementData).forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
          formData.append(key, value);
        }
      });

      // ✅ Important: send measurementId as a query param named exactly 'measureId'
      const response = await this.api.patch(
        "/patchUpdateHighwayMeasurement",
        formData,
        {
          params: { landAcqId: landAcqId }, // <-- correct!
        },
      );

      return {
        status: response.status,
        data: response.data,
      };
    } catch (error) {
      console.error("❌ Update Measurement Error:", error);
      throw error;
    }
  }

  async getHighwayMeasurement(
    districtName = null,
    talukaName = null,
    villageName = null,
    projectId = null,
    locationParams = {},
  ) {
    try {
      if (!projectId && !locationParams.proposalId) {
        throw new Error("At least projectId or proposalId must be provided");
      }

      const params = {};
      if (districtName) params.districtName = districtName;
      if (talukaName) params.talukaName = talukaName;
      if (villageName) params.villageName = villageName;
      if (projectId) params.projectId = projectId;
      if (locationParams.proposalId)
        params.proposalId = locationParams.proposalId;

      const response = await this.api.get(
        this.endpoints.GET_HIGHWAY_MEASUREMENT,
        { params },
      );

      return {
        status: response.status,
        data: response.data,
      };
    } catch (error) {
      console.error("Error fetching highway measurements:", error);
      throw new Error("Failed to fetch highway measurements");
    }
  }

  async getHighwayAllOwner(
    districtName = null,
    talukaName = null,
    villageName = null,
    projectId = null,
    proposalId = null,
  ) {
    try {
      if (!projectId && !proposalId) {
        throw new Error("At least projectId or proposalId must be provided");
      }

      const params = {};
      if (districtName) params.districtName = districtName;
      if (talukaName) params.talukaName = talukaName;
      if (villageName) params.villageName = villageName;
      if (projectId) params.projectId = projectId;
      if (proposalId) params.proposalId = proposalId;

      // Use axios directly to get full response
      const response = await axios.get(
        `${this.api.defaults.baseURL}/getHighwayAllOwner`,
        {
          params,
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
            ...this.api.defaults.headers,
          },
        },
      );

      return {
        status: response.status,
        data: response.data.landAcquisition || [],
      };
    } catch (error) {
      console.error("Error in getAllOwner API:", error);
      throw error;
    }
  }

  async patchHighwayUpdateMeasurement(measurementId, measurementData) {
    try {
      const formData = new FormData();

      // Add all fields to FormData
      Object.entries(measurementData).forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
          formData.append(key, value);
        }
      });

      // ✅ Important: send measurementId as a query param named exactly 'measureId'
      const response = await this.api.patch(
        "/patchUpdateHighwayMeasurement",
        formData,
        {
          params: { measureId: measurementId }, // <-- correct!
        },
      );

      return {
        status: response.status,
        data: response.data,
      };
    } catch (error) {
      console.error("❌ Update Measurement Error:", error);
      throw error;
    }
  }

  async getHighwayPAP(
    projectId,
    proposalId,
    districtName = null,
    talukaName = null,
    villageName = null,
  ) {
    try {
      if (!projectId || !proposalId) {
        throw new Error("Project ID and Proposal ID are required");
      }

      const params = {
        projectId,
        proposalId,
      };

      if (districtName) params.districtName = districtName;
      if (talukaName) params.talukaName = talukaName;
      if (villageName) params.villageName = villageName;

      const response = await this.get(this.endpoints.GET_HIGHWAY_PAP, params);

      return {
        status: 200,
        data: Array.isArray(response) ? response : [response],
      };
    } catch (error) {
      console.error("Error fetching highway PAP data:", error);
      throw new Error("Failed to fetch highway PAP data");
    }
  }

  async getHighwayAgency(
    projectId,
    proposalId,
    distName = null,
    talukaName = null,
    villName = null,
  ) {
    try {
      if (!projectId || !proposalId) {
        throw new Error("Project ID and Proposal ID are required");
      }

      const params = {
        projectId,
        proposalId,
      };

      if (distName) params.distName = distName;
      if (talukaName) params.talukaName = talukaName;
      if (villName) params.villName = villName;

      const response = await this.get(
        this.endpoints.GET_HIGHWAY_AGENCY,
        params,
      );

      return {
        status: 200,
        data: response,
      };
    } catch (error) {
      console.error("Error fetching highway agency:", error);
      throw new Error("Failed to fetch highway agency data");
    }
  }

  // Highway Tree Methods
  async getHighwayTree(projectId, proposalId, measurementId = null) {
    try {
      const params = { projectId, proposalId };
      if (measurementId) params.measurementId = measurementId;

      return this.get(this.endpoints.GET_HIGHWAY_TREE, params);
    } catch (error) {
      console.error("Error fetching highway tree:", error);
      throw error;
    }
  }

  async postAddHighwayTree(treeData) {
    try {
      const formData = new FormData();
      Object.entries(treeData).forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
          formData.append(key, value);
        }
      });

      const response = await this.api.post(
        this.endpoints.POST_ADD_HIGHWAY_TREE,
        formData,
      );
      return { status: response.status, data: response.data };
    } catch (error) {
      console.error("Error adding highway tree:", error);
      throw error;
    }
  }

  async patchUpdateHighwayTree(treeId, treeData) {
    try {
      if (!treeId || isNaN(treeId)) {
        throw new Error("Invalid or missing treeId");
      }

      const formData = new FormData();
      Object.entries(treeData).forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
          formData.append(key, value);
        }
      });

      const response = await this.api.patch(
        `${this.endpoints.PATCH_UPDATE_HIGHWAY_TREE}?treeId=${treeId}`,
        formData,
      );
      return { status: response.status, data: response.data };
    } catch (error) {
      console.error("Error updating highway tree:", error);
      throw error;
    }
  }

  // Highway Property Methods
  async getHighwayProperty(projectId, proposalId, measurementId = null) {
    try {
      const params = { projectId, proposalId };
      if (measurementId) params.measurementId = measurementId;

      return this.get(this.endpoints.GET_HIGHWAY_PROPERTY, params);
    } catch (error) {
      console.error("Error fetching highway property:", error);
      throw error;
    }
  }

  async postAddHighwayProperty(propertyData) {
    try {
      const formData = new FormData();
      Object.entries(propertyData).forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
          formData.append(key, value);
        }
      });

      const response = await this.api.post(
        this.endpoints.POST_ADD_HIGHWAY_PROPERTY,
        formData,
      );
      return { status: response.status, data: response.data };
    } catch (error) {
      console.error("Error adding highway property:", error);
      throw error;
    }
  }

  async getHighwayMeasurementByOwnerID(measurementId) {
    try {
      const response = await this.api.get(
        this.endpoints.GET_HIGHWAY_MEASUREMENT_BY_OWNER_ID,
        {
          params: { measurementId },
        },
      );
      return response.data; // Returns { status: 200, data: {...} }
    } catch (error) {
      console.error("Error in getMeasurementByOwnerID:", error);
      throw error;
    }
  }

  async patchUpdateHighwayProperty(propertyId, propertyData) {
    try {
      if (!propertyId || isNaN(propertyId)) {
        throw new Error("Invalid or missing propertyId");
      }

      const formData = new FormData();
      Object.entries(propertyData).forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
          formData.append(key, value);
        }
      });

      const response = await this.api.patch(
        `${this.endpoints.PATCH_UPDATE_HIGHWAY_PROPERTY}?propertyId=${propertyId}`,
        formData,
      );
      return { status: response.status, data: response.data };
    } catch (error) {
      console.error("Error updating highway property:", error);
      throw error;
    }
  }

  // Highway Covering Letter
  async getHighwayCoveringLetter(projectId, proposalId, type) {
    try {
      if (!projectId || !proposalId || !type) {
        throw new Error("projectId, proposalId, and type are required");
      }

      const response = await this.api.get(
        `${this.endpoints.GET_HIGHWAY_COVERING_LETTER}?projectId=${projectId}&proposalId=${proposalId}&type=${type}`,
      );
      return response;
    } catch (error) {
      console.error("Error fetching highway covering letter:", error);
      throw error;
    }
  }

  async postAddUpdateHighwayCoveringLetter(data) {
    try {
      const response = await this.post(
        this.endpoints.POST_ADD_UPDATE_HIGHWAY_COVERING_LETTER,
        data,
      );
      return response;
    } catch (error) {
      console.error("Error adding/updating highway covering letter:", error);
      throw new Error(
        `Failed to update highway covering letter: ${error.message}`,
      );
    }
  }

  // Asset Property
  // Tree
  async patchHighwayUpdateTree(treeId, payload) {
    try {
      if (!treeId || isNaN(treeId)) {
        throw new Error("Invalid or missing treeId");
      }

      const response = await this.api.patch(
        `${this.endpoints.PATCH_UPDATE_TREE}?treeId=${treeId}`,
        payload,
      );
      return response;
    } catch (error) {
      console.error("❌ Error in patchUpdateTree:", error);
      throw error;
    }
  }

  //Agency
  async getHighwayAgencyCompensation(
    projectId,
    proposalId,
    distName = null,
    talukaName = null,
    villName = null,
  ) {
    try {
      if (!projectId || !proposalId) {
        throw new Error("Project ID and Proposal ID are required");
      }

      // Build parameters object
      const params = {
        projectId,
        proposalId,
      };

      // Add optional parameters only if they exist
      if (distName) params.distName = distName;
      if (talukaName) params.talukaName = talukaName;
      if (villName) params.villName = villName;

      const response = await this.get("/getAgency", params);

      return {
        status: 200,
        data: response,
      };
    } catch (error) {
      console.error("Error fetching agency compensation:", error);
      console.error("Error details:", error.response?.data || error.message);
      throw new Error("Failed to fetch agency compensation data");
    }
  }

  //Highway JMR tracking
  async getHighwayTrackingSLR(projectId, proposalId, type = "SLR") {
    const url = `${this.endpoints.GET_HIGHWAY_BUTTON_DISABLE}?project_id=${projectId}&proposal_id=${proposalId}&type=${type}`;
    return this.get(url);
  }

  //For Assign surveyor
  async getHighwayAssignSurveyorButton(
    projectId,
    proposalId,
    type = "Surveyor",
  ) {
    const url = `${this.endpoints.GET_HIGHWAY_BUTTON_DISABLE}?project_id=${projectId}&proposal_id=${proposalId}&type=${type}`;
    return this.get(url);
  }

  //For Assign back  to dslr
  async getHighwayAssignBackToDSLRButton(projectId, proposalId, type = "SLRV") {
    const url = `${this.endpoints.GET_HIGHWAY_BUTTON_DISABLE}?project_id=${projectId}&proposal_id=${proposalId}&type=${type}`;
    return this.get(url);
  }

  //For send back to LAO
  async getHighwaySendBackToLAOButton(projectId, proposalId, type = "LAOV") {
    const url = `${this.endpoints.GET_HIGHWAY_BUTTON_DISABLE}?project_id=${projectId}&proposal_id=${proposalId}&type=${type}`;
    return this.get(url);
  }

  async getHighwayAgencyButton(projectId, proposalId, type = "Agency") {
    const url = `${this.endpoints.GET_HIGHWAY_BUTTON_DISABLE}?project_id=${projectId}&proposal_id=${proposalId}&type=${type}`;
    return this.get(url);
  }

  async postHighwayTrackingSurveyor(data, type = "Surveyor") {
    const url = `${this.endpoints.POST_HIGHWAY_TRACKING}?type=${type}`;
    return this.post(url, data);
  }

  async postHighwayTrackingbacktoLao(data, type = "LAOV") {
    const url = `${this.endpoints.POST_HIGHWAY_TRACKING}?type=${type}`;
    return this.post(url, data);
  }

  async postHighwayTrackingbacktoSlr(data, type = "SLRV") {
    const url = `${this.endpoints.POST_HIGHWAY_TRACKING}?type=${type}`;
    return this.post(url, data);
  }

  async postHighwayTrackingAgency(data, type) {
    const url = `${this.endpoints.POST_HIGHWAY_TRACKING}?type=${type}`;
    return this.post(url, data);
  }

  //Highway Agency to Compansation
  async postHighwayTrackingCompensation(data, type = "Compensation") {
    const url = `${this.endpoints.POST_HIGHWAY_TRACKING}?type=${type}`;
    return this.post(url, data);
  }

  //Highway for compensation tracking
  async getHighwayCompensationButton(
    projectId,
    proposalId,
    type = "Compensation",
  ) {
    const url = `${this.endpoints.GET_HIGHWAY_BUTTON_DISABLE}?project_id=${projectId}&proposal_id=${proposalId}&type=${type}`;
    return this.get(url);
  }

  // Nivada
  async getNivada(params = {}) {
    const queryParams = new URLSearchParams();

    queryParams.append("page", params.page || 1);
    queryParams.append("pageSize", params.pageSize || 12);

    if (params.district) queryParams.append("district", params.district);
    if (params.taluka) queryParams.append("taluka", params.taluka);
    if (params.village) queryParams.append("village", params.village);
    if (params.office) queryParams.append("office", params.office);
    if (params.prakaranKkramank !== undefined)
      queryParams.append("prakaranKramank", params.prakaranKkramank);
    if (params.yantrana) queryParams.append("yantrana", params.yantrana);
    if (params.acquiredFor)
      queryParams.append("acquiredFor", params.acquiredFor);
    if (params.projectName)
      queryParams.append("projectName", params.projectName);
    if (params.docType) queryParams.append("docType", params.docType);
    if (params.category) queryParams.append("category", params.category);

    const response = await this.get(
      `${this.endpoints.GET_NIVADA}?${queryParams.toString()}`,
    );

    return response;
  }

  async getNivadaTotalCount(params = {}) {
    const queryParams = new URLSearchParams();

    queryParams.append("page", params.page || 1);
    queryParams.append("pageSize", params.pageSize || 12);

    if (params.district) queryParams.append("district", params.district);
    if (params.tahsil) queryParams.append("tahsil", params.tahsil);
    if (params.village) queryParams.append("village", params.village);
    if (params.office) queryParams.append("office", params.office);
    if (params.prakaranKkramank)
      queryParams.append("prakaranKramank", params.prakaranKkramank);
    if (params.yantrana) queryParams.append("yantrana", params.yantrana);
    if (params.acquiredFor)
      queryParams.append("acquiredFor", params.acquiredFor);
    if (params.projectName)
      queryParams.append("projectName", params.projectName);
    if (params.docType) queryParams.append("docType", params.docType);
    if (params.category) queryParams.append("category", params.category);
    if (params.ownerName && params.ownerName.trim()) {
      queryParams.append("ownerName", params.ownerName.trim());
    }

    const response = await this.get(
      `${this.endpoints.GET_NIVADA_TOTAL_COUNT}?${queryParams.toString()}`,
    );

    return response;
  }

  async getNivadaOwner(params = {}) {
    const queryParams = new URLSearchParams();

    if (params.prakaranKkramank)
      queryParams.append("prakaranKramank", params.prakaranKkramank);

    const response = await this.get(
      `${this.endpoints.GET_NIVADA_OWNER}?${queryParams.toString()}`,
    );

    return response;
  }

  async getNivadaCategory(params = {}) {
    const queryParams = new URLSearchParams();

    if (params.district) queryParams.append("district", params.district);
    if (params.tahsil) queryParams.append("tahsil", params.tahsil);
    if (params.village) queryParams.append("village", params.village);
    if (params.docType) queryParams.append("docType", params.docType);
    if (params.category) queryParams.append("category", params.category);
    if (params.office) queryParams.append("office", params.office);

    const response = await this.get(
      `${this.endpoints.GET_NIVADA_CATEGORY}?${queryParams.toString()}`,
    );

    return response;
  }

  async getNivadaProjects(params = {}) {
    const queryParams = new URLSearchParams();

    if (params.district) queryParams.append("district", params.district);
    if (params.tahsil) queryParams.append("tahsil", params.tahsil);
    if (params.village) queryParams.append("village", params.village);
    if (params.docType) queryParams.append("docType", params.docType);
    if (params.category) queryParams.append("category", params.category);
    if (params.projectName)
      queryParams.append("projectName", params.projectName);
    if (params.office) queryParams.append("office", params.office);

    const response = await this.get(
      `${this.endpoints.GET_NIVADA_PROJECT}?${queryParams.toString()}`,
    );
    return response;
  }

  async getNivadaDistrict(
    projectname,
    docType,
    category,
    taluka,
    village,
    office,
  ) {
    const params = new URLSearchParams();

    if (projectname) {
      params.append("projectname", projectname);
    }

    if (docType) {
      params.append("docType", docType);
    }

    if (category) {
      params.append("category", category);
    }

    if (taluka) params.append("taluka", taluka);
    if (village) params.append("village", village);
    if (office) params.append("office", office);

    const response = await this.get(
      `${this.endpoints.GET_NIVADA_DISTRICT}?${params.toString()}`,
    );

    return response;
  }

  async getNivadaTaluka(
    district,
    village,
    projectName,
    docType,
    category,
    office,
  ) {
    const params = new URLSearchParams();

    if (district) {
      params.append("district", district);
    }

    if (village) params.append("village", village);
    if (office) params.append("office", office);

    if (projectName) {
      params.append("projectName", projectName);
    }

    if (docType) {
      params.append("docType", docType);
    }

    if (category) {
      params.append("category", category);
    }

    const response = await this.get(
      `${this.endpoints.GET_NIVADA_TALUKA}?${params.toString()}`,
    );

    return response;
  }

  async getNivadaVillage(
    district,
    taluka,
    projectName,
    docType,
    category,
    office,
  ) {
    const params = new URLSearchParams();

    if (district) {
      params.append("district", district);
    }

    if (taluka) {
      params.append("taluka", taluka);
    }

    if (projectName) {
      params.append("projectName", projectName);
    }

    if (docType) {
      params.append("docType", docType);
    }

    if (category) {
      params.append("category", category);
    }

    if (office) params.append("office", office);

    const response = await this.get(
      `${this.endpoints.GET_NIVADA_VILLAGE}?${params.toString()}`,
    );

    return response;
  }

  async getNivadaDocument(volumnNo, pageNo) {
    const response = await this.get(
      `${this.endpoints.GET_NIVADA_DOCUMENT}?volumnNo=${volumnNo}&pageNo=${pageNo}`,
    );
    return response;
  }

  async getNivadaDocType(params = {}) {
    const queryParams = new URLSearchParams();

    if (params.district) queryParams.append("district", params.district);
    if (params.tahsil) queryParams.append("tahsil", params.tahsil);
    if (params.village) queryParams.append("village", params.village);
    if (params.projectName)
      queryParams.append("projectName", params.projectName);
    if (params.category) queryParams.append("category", params.category);
    if (params.office) queryParams.append("office", params.office);

    const queryString = queryParams.toString();

    const url = queryString
      ? `${this.endpoints.GET_NIVADA_DOC_TYPE}?${queryString}`
      : this.endpoints.GET_NIVADA_DOC_TYPE;

    const response = await this.get(url);

    return response;
  }

  async getNivadaOffice(params = {}) {
    const queryParams = new URLSearchParams();

    if (params.district) queryParams.append("district", params.district);
    if (params.tahsil) queryParams.append("tahsil", params.tahsil);
    if (params.village) queryParams.append("village", params.village);
    if (params.projectName)
      queryParams.append("projectName", params.projectName);
    if (params.docType) queryParams.append("docType", params.docType);
    if (params.category) queryParams.append("category", params.category);

    const response = await this.get(
      `${this.endpoints.GET_NIVADA_OFFICE}?${queryParams.toString()}`,
    );

    return response;
  }
  //Delete Family Details
  async deleteFamilyDetails(familyId) {
    try {
      const response = await this.api.delete(
        `${this.endpoints.DELETE_FAMILY_DETAILS}?familyId=${familyId}`,
      );

      return { status: response.status, data: response.data };
    } catch (error) {
      console.error(":x: Delete Family Details Error:", error);
      throw error;
    }
  }

  //Delete Family Property
  async deleteFamilyProperty(propertyId) {
    try {
      const response = await this.api.delete(
        `${this.endpoints.DELETE_FAMILY_PROPERTY}?propertyId=${propertyId}`,
      );
      return { status: response.status, data: response.data };
    } catch (error) {
      console.error(":x: Delete Family Property Error:", error);
      throw error;
    }
  }

  // Get KJP Tabapavti / Kabja Pauti
  async getKJPTabapavti(projectId = null, proposalId = null) {
    if (projectId && proposalId) {
      return (
        await this.api.get(this.endpoints.GET_KJP_TABAPAVTI, {
          params: { projectId, proposalId },
        })
      ).data;
    } else {
      throw new Error("projectId and proposalId are required!");
    }
  }

  // Add or Update KJP Tabapavti / Kabja Pauti
  async postAddUpdateKJPTabapavti(payload) {
    return (
      await this.api.post(
        this.endpoints.POST_ADD_UPDATE_KJP_TABAPAVTI,
        payload,
      )
    );
  }
}


// Export a single instance of the class
const apiService = new ApiService();
export default apiService;
